// Données SEO locales — contenu rédigé, unique par zone. Aucun import (fichier consommé aussi par le générateur de sitemap).

const IMG = {
  salon: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1600&q=80",
  peinture: "https://images.unsplash.com/photo-1503174971373-b1f69850bded?auto=format&fit=crop&w=1600&q=80",
  sol: "https://images.unsplash.com/photo-1639663742190-1b3dba2eebcf?auto=format&fit=crop&w=1600&q=80",
  sdb: "https://images.unsplash.com/photo-1564540579594-0930edb6de43?auto=format&fit=crop&w=1600&q=80",
  cuisine: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?auto=format&fit=crop&w=1600&q=80",
  neuf: "https://images.unsplash.com/photo-1680416124510-5eae1beca412?auto=format&fit=crop&w=1600&q=80",
  chantier: "https://images.unsplash.com/photo-1741764014072-68953e93cd48?auto=format&fit=crop&w=1600&q=80",
  parisien: "https://images.unsplash.com/photo-1680786661510-70f05296870a?auto=format&fit=crop&w=1600&q=80",
  sejour: "https://images.unsplash.com/photo-1723642611178-d192c6e3597e?auto=format&fit=crop&w=1600&q=80",
  chambre: "https://images.unsplash.com/photo-1721742146903-5b37cb82ff54?auto=format&fit=crop&w=1600&q=80",
};

export const PRESTATIONS = [
  "Peinture & préparation des supports",
  "Placo, cloisons & faux plafonds",
  "Sols, parquet & carrelage",
  "Électricité intérieure",
  "Plomberie intérieure",
  "Salle de bains clé en main",
  "Cuisine & agencement",
  "Menuiserie intérieure",
  "Isolation intérieure",
  "Second œuvre en logement neuf",
];

const FAQ_COMMUNE = [
  {
    q: "Le devis et le déplacement sont-ils gratuits ?",
    a: "Oui. Le déplacement, la visite technique et le devis détaillé sont entièrement gratuits et sans engagement. Vous pouvez aussi obtenir une première estimation en ligne en cinq minutes, avant même la visite.",
  },
  {
    q: "RAMA DÉCO intervient-il sur le gros œuvre ?",
    a: "Non. RAMA DÉCO est spécialisé dans les travaux intérieurs, la rénovation et le second œuvre. Nous n'intervenons ni sur les fondations, ni sur les murs porteurs, ni sur la charpente ou la structure du bâtiment.",
  },
];

/**
 * type: "ville" | "departement" | "region"
 */
export const ZONES = [
  {
    slug: "villepinte",
    name: "Villepinte",
    type: "ville",
    cp: "93420",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.chantier,
    title: "Rénovation & travaux intérieurs à Villepinte (93420) | RAMA DÉCO",
    description:
      "Entreprise de rénovation intérieure à Villepinte : peinture, placo, sols, salle de bains, électricité et plomberie. Devis gratuit, estimation en ligne en 5 minutes.",
    h1: "Rénovation et travaux intérieurs à Villepinte",
    kicker: "Notre ville · Seine-Saint-Denis",
    intro: [
      "RAMA DÉCO est installé à Villepinte, 30B rue des Mésanges. C'est ici que nous stockons notre matériel, que nous préparons nos chantiers et que nous réalisons chaque année une grande partie de nos rénovations intérieures : pavillons du Vert-Galant, résidences de la Haie Bertrand, appartements du Parc de la Noue et locaux professionnels du secteur Paris Nord 2.",
      "Être votre voisin change concrètement les choses : une visite technique peut souvent être organisée dans la semaine, les approvisionnements se font sans frais de déplacement, et si une reprise de finition est nécessaire après la livraison, nous sommes à dix minutes de chez vous.",
    ],
    contexte: [
      { t: "Pavillons des années 60 à 80", d: "Vert-Galant, Fontaine Mallet : peintures fatiguées, sols d'origine, salles de bains à reprendre entièrement et électricité à remettre aux normes intérieures." },
      { t: "Copropriétés et résidences", d: "La Noue, Merisiers : rafraîchissements avant location, doublages phoniques entre logements et remise en état après sinistre." },
      { t: "Locaux et bureaux Paris Nord 2", d: "Cloisonnement placo, faux plafonds, peinture et sols souples, avec interventions possibles en horaires décalés." },
    ],
    typologies: ["Pavillon individuel", "Appartement en copropriété", "Local professionnel", "Logement neuf à finir"],
    delai: "Visite technique généralement sous 48 à 72 h",
    faq: [
      {
        q: "Où se trouvent vos bureaux à Villepinte ?",
        a: "RAMA DÉCO est basé au 30B rue des Mésanges, 93420 Villepinte. Nous recevons sur rendez-vous du lundi au samedi, de 8h à 19h, et nous nous déplaçons gratuitement sur toute la commune.",
      },
      {
        q: "Combien de temps dure la rénovation d'un pavillon à Villepinte ?",
        a: "Pour un pavillon de 90 à 110 m² avec peinture complète, sols, salle de bains et reprises électriques, comptez en moyenne 4 à 7 semaines de chantier, planning détaillé remis avant démarrage.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["tremblay-en-france", "sevran", "aulnay-sous-bois", "le-blanc-mesnil", "vaujours"],
  },
  {
    slug: "paris",
    name: "Paris",
    type: "ville",
    cp: "75",
    dept: "Paris (75)",
    img: IMG.parisien,
    title: "Rénovation d'appartement à Paris | Entreprise de travaux intérieurs — RAMA DÉCO",
    description:
      "Rénovation d'appartement à Paris : peinture, parquet, salle de bains, cuisine, électricité. Entreprise tous corps d'état intérieurs, devis gratuit et estimation immédiate.",
    h1: "Rénovation d'appartement à Paris",
    kicker: "Paris intra-muros · 75",
    intro: [
      "Rénover à Paris, c'est composer avec l'immeuble autant qu'avec le logement : escaliers étroits, absence d'ascenseur, horaires de nuisances imposés par le règlement de copropriété, protections obligatoires dans les parties communes et stationnement à réserver auprès de la Ville. Nous préparons ces contraintes en amont, avant la première dépose.",
      "Nos chantiers parisiens sont majoritairement des appartements haussmanniens et des studios à optimiser : reprise de plâtre et de moulures, ponçage et vitrification de parquet, remplacement de faïences, création de salle d'eau, redistribution de cloisons non porteuses et remise à niveau de l'électricité intérieure.",
    ],
    contexte: [
      { t: "Haussmannien et pierre de taille", d: "Enduits au plâtre, corniches, parquet point de Hongrie, portes à double vantail : nous travaillons dans le respect des éléments d'origine." },
      { t: "Studios et petites surfaces", d: "Optimisation au centimètre : salle d'eau compacte, rangements sur mesure, cuisine linéaire, gain de lumière par les teintes et les finitions." },
      { t: "Contraintes de copropriété", d: "Déclaration de travaux, horaires 8h–19h en semaine, protection des parties communes, évacuation quotidienne des gravats, propreté irréprochable." },
    ],
    typologies: ["Appartement haussmannien", "Studio / T1", "Immeuble sans ascenseur", "Local commercial en pied d'immeuble"],
    delai: "Visite technique sous 3 à 5 jours ouvrés",
    prixNote:
      "À Paris, les contraintes d'accès, de stationnement et d'évacuation pèsent autant que les travaux eux-mêmes. Elles sont toujours identifiées lors de la visite et écrites noir sur blanc dans le devis, jamais découvertes en cours de chantier.",
    faq: [
      {
        q: "Comment se déroule une rénovation complète d'appartement à Paris ?",
        a: "Dépose et évacuation, puis réseaux (plomberie et électricité), cloisons et plâtrerie, sols, pièces d'eau, peinture et finitions. Le planning daté est remis avant démarrage et suivi en ligne dans votre espace projet.",
      },
      {
        q: "Gérez-vous les démarches auprès de la copropriété ?",
        a: "Nous préparons le dossier technique à transmettre au syndic (nature des travaux, planning, assurances, décennale) et nous respectons les horaires autorisés. La déclaration reste au nom du propriétaire, mais nous fournissons toutes les pièces.",
      },
      {
        q: "Intervenez-vous dans tous les arrondissements ?",
        a: "Oui, dans les 20 arrondissements. Nos équipes partent de Villepinte et rejoignent Paris par l'A104 et l'A3 ; la logistique matériel est planifiée la veille pour éviter les allers-retours.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["saint-denis", "montreuil", "pantin", "aubervilliers"],
  },
  {
    slug: "aulnay-sous-bois",
    name: "Aulnay-sous-Bois",
    type: "ville",
    cp: "93600",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.sejour,
    title: "Rénovation intérieure à Aulnay-sous-Bois (93600) | RAMA DÉCO",
    description:
      "Travaux de rénovation intérieure à Aulnay-sous-Bois : peinture, placo, sols, salle de bains, cuisine. Entreprise locale, devis gratuit et estimation en ligne.",
    h1: "Rénovation intérieure à Aulnay-sous-Bois",
    kicker: "À 6 km de nos bureaux",
    intro: [
      "Aulnay-sous-Bois est l'une des communes où nous intervenons le plus souvent. Le parc immobilier y est très contrasté : pavillons meulières du Vieux Pays, maisons des années 30 du quartier Nonneville, grands ensembles de la Rose des Vents et programmes neufs autour de la gare RER B.",
      "Sur les maisons anciennes, nous rencontrons régulièrement les mêmes sujets : plâtres à reprendre, planchers bois à stabiliser avant pose de sol, salles de bains d'origine à refaire intégralement et tableaux électriques à moderniser. Nous chiffrons chaque poste séparément pour que vous puissiez arbitrer sans opacité.",
    ],
    contexte: [
      { t: "Meulières et maisons de ville", d: "Reprise d'enduits intérieurs, doublage isolant non structurel, remise en état des menuiseries intérieures et des sols anciens." },
      { t: "Appartements à rafraîchir", d: "Nonneville, Chanteloup, Ambourget : peinture complète, sols souples ou stratifiés, remise en état avant vente ou location." },
      { t: "Programmes neufs", d: "Finitions et second œuvre après livraison promoteur : peinture, faïence, sols, réserves à lever." },
    ],
    typologies: ["Meulière / maison ancienne", "Pavillon années 70", "Appartement en résidence", "Neuf livré brut"],
    delai: "Intervention rapide, 15 minutes de trajet depuis Villepinte",
    faq: [
      {
        q: "Rénovez-vous les maisons meulières d'Aulnay ?",
        a: "Oui, pour tout ce qui concerne l'intérieur : plâtrerie, doublages, peinture, sols, électricité et plomberie intérieures, salle de bains et cuisine. Les interventions sur la structure ou la façade porteuse ne font pas partie de notre périmètre.",
      },
      {
        q: "Pouvez-vous intervenir sur un seul lot, par exemple la peinture ?",
        a: "Bien sûr. Beaucoup de nos clients d'Aulnay-sous-Bois nous confient d'abord un lot unique (peinture ou sols), puis nous rappellent pour la suite. Le devis reste détaillé et sans minimum de commande imposé.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["villepinte", "sevran", "le-blanc-mesnil", "drancy", "tremblay-en-france"],
  },
  {
    slug: "tremblay-en-france",
    name: "Tremblay-en-France",
    type: "ville",
    cp: "93290",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.peinture,
    title: "Entreprise de rénovation à Tremblay-en-France (93290) | RAMA DÉCO",
    description:
      "Rénovation et travaux intérieurs à Tremblay-en-France : peinture, cloisons, sols, salle de bains, électricité. Devis gratuit, entreprise voisine basée à Villepinte.",
    h1: "Rénovation et second œuvre à Tremblay-en-France",
    kicker: "Commune limitrophe",
    intro: [
      "Tremblay-en-France jouxte directement Villepinte : nos équipes y arrivent en moins de dix minutes. Nous y rénovons surtout des pavillons du Vieux-Pays et des logements du Vert-Galant, ainsi que des locaux tertiaires proches de la zone aéroportuaire.",
      "La proximité de Roissy explique une demande fréquente : l'isolation phonique intérieure. Nous posons des doublages acoustiques non structurels sur les murs et les plafonds, qui réduisent sensiblement le bruit perçu sans toucher à la structure du bâtiment.",
    ],
    contexte: [
      { t: "Confort acoustique", d: "Doublages phoniques placo + laine minérale, traitement des plafonds, calfeutrement des passages de gaines." },
      { t: "Pavillons du Vieux-Pays", d: "Rénovation complète intérieure : dépose non structurelle, plâtrerie, peinture, sols, sanitaires et électricité." },
      { t: "Locaux professionnels", d: "Cloisonnement de bureaux, faux plafonds démontables, sols souples, peinture, chantiers en site occupé." },
    ],
    typologies: ["Pavillon", "Appartement", "Bureaux / local d'activité", "Logement locatif"],
    delai: "Visite sous 48 h, moins de 10 minutes de trajet",
    faq: [
      {
        q: "Pouvez-vous améliorer l'isolation phonique de mon logement à Tremblay ?",
        a: "Oui, par des doublages intérieurs acoustiques (ossature métallique, laine minérale haute densité, plaques phoniques) sur murs et plafonds. Ces travaux ne touchent pas à la structure et apportent un gain immédiatement perceptible.",
      },
      {
        q: "Travaillez-vous pour les entreprises de la zone aéroportuaire ?",
        a: "Oui. Nous intervenons pour des locaux tertiaires et commerciaux, y compris en site occupé, avec possibilité d'horaires décalés et de phasage par zones pour ne pas interrompre l'activité.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["villepinte", "sevran", "mitry-mory", "roissy-en-france", "vaujours"],
  },
  {
    slug: "sevran",
    name: "Sevran",
    type: "ville",
    cp: "93270",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.sol,
    title: "Rénovation appartement & maison à Sevran (93270) | RAMA DÉCO",
    description:
      "Travaux intérieurs à Sevran : rénovation d'appartement, peinture, sols, salle de bains, mise aux normes électriques intérieures. Devis gratuit sous 48 h.",
    h1: "Travaux de rénovation à Sevran",
    kicker: "À 5 minutes de Villepinte",
    intro: [
      "À Sevran, nous rénovons aussi bien des appartements de Rougemont et des Beaudottes que des pavillons de Freinville et de Sevran-Livry. Les demandes les plus fréquentes concernent la remise en état avant location, la réfection de salle de bains et le changement des sols.",
      "Nous intervenons régulièrement pour des propriétaires bailleurs qui ont besoin d'un chantier court, propre et daté précisément. Nous livrons alors un planning ferme, poste par poste, et un état des lieux photographique à la remise des clés.",
    ],
    contexte: [
      { t: "Remise en état locative", d: "Peinture complète, sols, reprises de plâtre, sanitaires et robinetterie : chantier calibré en 5 à 12 jours selon la surface." },
      { t: "Salles de bains et WC", d: "Dépose, réseaux, étanchéité, carrelage et faïence, sanitaires, meuble et éclairage." },
      { t: "Pavillons à moderniser", d: "Ouverture non porteuse de cloison légère, nouvelles cloisons, faux plafonds avec spots encastrés." },
    ],
    typologies: ["Appartement locatif", "Pavillon familial", "Studio", "Copropriété"],
    delai: "Visite technique sous 48 h",
    faq: [
      {
        q: "Combien de temps pour remettre en état un appartement avant location à Sevran ?",
        a: "Pour un T3 de 60 à 70 m² avec peinture complète, sols et reprise de la salle de bains, comptez 8 à 12 jours ouvrés. Un simple rafraîchissement peinture peut être livré en 4 à 6 jours.",
      },
      {
        q: "Travaillez-vous pour les propriétaires bailleurs et les agences ?",
        a: "Oui, régulièrement. Nous fournissons un devis détaillé, un planning ferme, des photos avant/après et une facture conforme, ce qui facilite la gestion locative et la justification des travaux.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["villepinte", "aulnay-sous-bois", "livry-gargan", "tremblay-en-france", "vaujours"],
  },
  {
    slug: "le-blanc-mesnil",
    name: "Le Blanc-Mesnil",
    type: "ville",
    cp: "93150",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.chambre,
    title: "Rénovation intérieure au Blanc-Mesnil (93150) | RAMA DÉCO",
    description:
      "Entreprise de travaux intérieurs au Blanc-Mesnil : peinture, placo, parquet, carrelage, salle de bains, cuisine. Devis gratuit et estimation en ligne immédiate.",
    h1: "Rénovation intérieure au Blanc-Mesnil",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "Le Blanc-Mesnil compte de nombreux pavillons d'après-guerre et des résidences des années 60 à 80. Deux sujets reviennent en permanence dans nos devis : les sols d'origine (dalles collées, moquettes, planchers fatigués) et les cuisines fermées que les propriétaires souhaitent ouvrir.",
      "Ouvrir une cuisine n'est possible que sur une cloison non porteuse : nous vérifions systématiquement la nature du mur avant tout engagement, et nous vous le disons clairement si le projet sort de notre périmètre. Le reste — sol, réseaux, faïence, peinture, éclairage — est réalisé par nos équipes.",
    ],
    contexte: [
      { t: "Sols à refaire", d: "Dépose des revêtements anciens, ragréage, pose de stratifié, parquet contrecollé, carrelage ou sol souple." },
      { t: "Cuisines et espaces de vie", d: "Retrait de cloison légère, déplacement des points d'eau et d'électricité, crédence, sol continu." },
      { t: "Confort thermique intérieur", d: "Doublages isolants non structurels sur murs froids et rampants, sans intervention sur la structure." },
    ],
    typologies: ["Pavillon d'après-guerre", "Appartement années 70", "Maison de ville", "Bien à rafraîchir"],
    delai: "Visite technique sous 72 h",
    faq: [
      {
        q: "Puis-je ouvrir ma cuisine sur le séjour ?",
        a: "Uniquement si la cloison concernée n'est pas porteuse. Nous le contrôlons lors de la visite technique. Si le mur est porteur, le projet relève du gros œuvre et sort de notre périmètre : nous vous le signalons immédiatement.",
      },
      {
        q: "Faut-il un ragréage avant la pose d'un nouveau sol ?",
        a: "Dans la majorité des logements du Blanc-Mesnil que nous rénovons, oui : les supports présentent des différences de niveau supérieures aux tolérances de pose. Le ragréage est alors chiffré séparément, au m².",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["aulnay-sous-bois", "drancy", "le-bourget", "villepinte", "bobigny"],
  },
  {
    slug: "bobigny",
    name: "Bobigny",
    type: "ville",
    cp: "93000",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.salon,
    title: "Travaux de rénovation à Bobigny (93000) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Bobigny : appartements, bureaux et locaux. Peinture, cloisons, sols, sanitaires, électricité intérieure. Devis gratuit, entreprise du 93.",
    h1: "Rénovation intérieure et tertiaire à Bobigny",
    kicker: "Préfecture du 93",
    intro: [
      "Bobigny concentre logements collectifs, sièges administratifs et locaux tertiaires. Nos chantiers y sont donc de deux natures : rénovation d'appartements en copropriété, et aménagement de bureaux avec cloisonnement, faux plafonds et sols souples.",
      "Pour les locaux professionnels, nous travaillons souvent en site occupé, par zones et en horaires aménagés, avec un balisage propre et une remise en service quotidienne des espaces. Pour les logements, nous appliquons le même protocole de propreté : protections intégrales et évacuation régulière des déchets.",
    ],
    contexte: [
      { t: "Aménagement de bureaux", d: "Cloisons placo et vitrées non porteuses, faux plafonds acoustiques, dalles de sol, peinture, luminaires encastrés." },
      { t: "Appartements en copropriété", d: "Rafraîchissement, salle de bains, cuisine, sols, mise en conformité électrique intérieure." },
      { t: "Chantiers en site occupé", d: "Phasage, horaires aménagés, protections et nettoyage quotidien pour maintenir l'activité." },
    ],
    typologies: ["Bureaux / tertiaire", "Appartement en copropriété", "Local commercial", "Logement social rénové"],
    delai: "Visite sous 3 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous rénover des bureaux sans interrompre notre activité ?",
        a: "Oui. Nous découpons le chantier en zones, travaillons en horaires décalés si nécessaire (tôt le matin, en soirée ou le samedi) et remettons chaque espace en état d'usage à la fin de chaque intervention.",
      },
      {
        q: "Fournissez-vous les attestations d'assurance pour un bailleur professionnel ?",
        a: "Oui : Kbis, attestation de responsabilité civile professionnelle et garantie décennale sont transmis avec le devis, ainsi que le planning et le plan de prévention si le site l'exige.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["drancy", "le-blanc-mesnil", "pantin", "montreuil", "noisy-le-sec"],
  },
  {
    slug: "drancy",
    name: "Drancy",
    type: "ville",
    cp: "93700",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.sdb,
    title: "Rénovation salle de bains & appartement à Drancy (93700) | RAMA DÉCO",
    description:
      "Entreprise de rénovation à Drancy : salle de bains, cuisine, peinture, sols, placo et électricité intérieure. Devis gratuit et estimation en ligne en 5 minutes.",
    h1: "Rénovation intérieure à Drancy",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "À Drancy, la majorité de nos chantiers concerne des salles de bains et des cuisines datant des années 70 et 80, dans des pavillons comme dans des appartements. Les réseaux sont souvent à reprendre entièrement : alimentation, évacuation, ventilation et alimentation électrique dédiée.",
      "Nous réalisons ces travaux dans l'ordre technique correct — dépose, réseaux, étanchéité, carrelage, sanitaires, finitions — et nous documentons chaque étape en photo. Vous savez précisément où en est le chantier, même sans être sur place.",
    ],
    contexte: [
      { t: "Salle de bains clé en main", d: "Douche à l'italienne, receveur extra-plat, meuble suspendu, sèche-serviettes, faïence toute hauteur." },
      { t: "Réseaux intérieurs", d: "Reprise d'alimentation et d'évacuation, création de point d'eau, ligne électrique dédiée et protection différentielle." },
      { t: "Rafraîchissement global", d: "Peinture, sols et menuiseries intérieures pour homogénéiser l'ensemble du logement après les pièces d'eau." },
    ],
    typologies: ["Pavillon", "Appartement", "Salle de bains seule", "Rénovation par étapes"],
    delai: "Visite technique sous 72 h",
    faq: [
      {
        q: "Combien de temps dure la réfection d'une salle de bains à Drancy ?",
        a: "En moyenne 10 à 15 jours ouvrés, temps de séchage compris : dépose, réseaux, étanchéité, carrelage, sanitaires et finitions. Lorsque c'est possible, nous maintenons un WC utilisable pendant toute la durée du chantier.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["le-blanc-mesnil", "bobigny", "aulnay-sous-bois", "le-bourget", "villepinte"],
  },
  {
    slug: "le-bourget",
    name: "Le Bourget",
    type: "ville",
    cp: "93350",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.neuf,
    title: "Rénovation & second œuvre au Bourget (93350) | RAMA DÉCO",
    description:
      "Travaux intérieurs au Bourget : second œuvre en logement neuf, peinture, placo, sols, finitions. Entreprise du 93, devis gratuit et planning ferme.",
    h1: "Second œuvre et rénovation au Bourget",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "Le Bourget se transforme vite : nouveaux programmes immobiliers, résidences livrées brutes et logements anciens à moderniser cohabitent sur un territoire réduit. Nous y intervenons pour les lots intérieurs de second œuvre autant que pour la rénovation classique.",
      "Sur les logements neufs, notre rôle est clair : cloisons de distribution, enduits et bandes, peinture, sols, faïence, portes intérieures et finitions. Nous levons également les réserves signalées à la livraison, avec un rapport écrit et photographique.",
    ],
    contexte: [
      { t: "Lots intérieurs en neuf", d: "Placo, bandes, enduits, peinture, sols, faïence, menuiseries intérieures et finitions soignées." },
      { t: "Levée de réserves", d: "Reprise des défauts constatés à la livraison, avec traçabilité photo poste par poste." },
      { t: "Ancien à moderniser", d: "Rafraîchissement complet, salle de bains, cuisine, électricité intérieure remise à niveau." },
    ],
    typologies: ["Logement neuf livré brut", "Appartement ancien", "Pavillon", "Local d'activité"],
    delai: "Visite sous 3 jours ouvrés",
    faq: [
      {
        q: "Intervenez-vous après la livraison d'un logement neuf ?",
        a: "Oui, c'est une part importante de notre activité : finitions non prévues par le promoteur, peinture, sols, faïence complémentaire, portes, plinthes, et reprise des réserves constatées.",
      },
      {
        q: "Travaillez-vous en sous-traitance pour des promoteurs ?",
        a: "Oui, sur les lots de second œuvre intérieur uniquement. Nous fournissons décennale, RC pro et attestation de vigilance URSSAF, et nous respectons les plannings tous corps d'état.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["drancy", "le-blanc-mesnil", "bobigny", "saint-denis", "aulnay-sous-bois"],
  },
  {
    slug: "livry-gargan",
    name: "Livry-Gargan",
    type: "ville",
    cp: "93190",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.cuisine,
    title: "Rénovation de maison à Livry-Gargan (93190) | RAMA DÉCO",
    description:
      "Rénovation intérieure de maison à Livry-Gargan : cuisine, salle de bains, peinture, sols, placo, électricité. Devis gratuit, entreprise locale de Seine-Saint-Denis.",
    h1: "Rénovation de maison à Livry-Gargan",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "Livry-Gargan est une commune de pavillons : maisons des années 30, constructions des années 60 et extensions plus récentes. Nos chantiers y sont souvent des rénovations globales menées pièce par pièce, avec des familles qui restent sur place pendant les travaux.",
      "Cela impose une organisation précise : phasage par zone, protection des espaces de vie, un seul interlocuteur joignable, et un nettoyage en fin de journée. C'est notre manière de travailler par défaut, pas une option.",
    ],
    contexte: [
      { t: "Cuisine complète", d: "Réseaux, sol, crédence, faïence, éclairage et coordination avec le cuisiniste ou le mobilier existant." },
      { t: "Rénovation par phases", d: "Chantier découpé par pièces pour permettre à la famille de rester dans le logement." },
      { t: "Combles et sous-sols aménagés", d: "Doublages, cloisons légères, plafonds, sols et électricité, hors intervention structurelle." },
    ],
    typologies: ["Maison des années 30", "Pavillon 1960-1980", "Combles aménagés", "Sous-sol aménagé"],
    delai: "Visite technique sous 72 h",
    faq: [
      {
        q: "Peut-on rester dans la maison pendant les travaux ?",
        a: "Oui, dans la grande majorité des cas. Nous phasons le chantier pièce par pièce, protégeons les circulations, isolons les zones poussiéreuses et nettoyons chaque soir. Seules les périodes de réfection de pièce d'eau demandent une organisation particulière.",
      },
      {
        q: "Pouvez-vous aménager mes combles à Livry-Gargan ?",
        a: "Nous réalisons tout l'aménagement intérieur : doublages isolants, cloisons non porteuses, plafonds, sols, électricité et finitions. En revanche, la modification de la charpente ou du plancher porteur relève du gros œuvre et n'entre pas dans notre périmètre.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["sevran", "vaujours", "aulnay-sous-bois", "villepinte", "noisy-le-sec"],
  },
  {
    slug: "vaujours",
    name: "Vaujours",
    type: "ville",
    cp: "93410",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.sejour,
    title: "Travaux intérieurs à Vaujours (93410) | RAMA DÉCO",
    description:
      "Entreprise de rénovation intérieure à Vaujours : peinture, placo, sols, salle de bains, électricité. Devis gratuit, intervention rapide depuis Villepinte.",
    h1: "Travaux intérieurs à Vaujours",
    kicker: "À 8 minutes de Villepinte",
    intro: [
      "Vaujours est une commune résidentielle où nous rénovons principalement des maisons individuelles. Les projets sont souvent conduits par des propriétaires qui gardent leur bien longtemps : ils privilégient des matériaux durables plutôt qu'un rendu rapide.",
      "Nous adaptons nos propositions à cette logique : supports préparés sérieusement, peintures de gamme professionnelle, sols résistants, et une transparence complète sur les références utilisées, indiquées dans le devis.",
    ],
    contexte: [
      { t: "Rénovation durable", d: "Préparation soignée des supports, peintures professionnelles, sols résistants au passage, finitions garanties." },
      { t: "Maisons individuelles", d: "Séjour, chambres, couloirs, escaliers intérieurs, pièces d'eau : chantier global ou par lots." },
      { t: "Petits travaux qualifiés", d: "Reprise de fissures non structurelles, faux plafond avec spots, pose de plinthes et portes intérieures." },
    ],
    typologies: ["Maison individuelle", "Pavillon récent", "Appartement", "Rénovation partielle"],
    delai: "Visite sous 48 h",
    faq: [
      {
        q: "Acceptez-vous les chantiers de petite taille ?",
        a: "Oui. Une pièce à repeindre, un faux plafond, une porte intérieure à poser : nous chiffrons aussi les interventions ciblées, avec le même devis détaillé et la même garantie de finition.",
      },
      {
        q: "Quelles peintures utilisez-vous ?",
        a: "Des gammes professionnelles adaptées à chaque support et à chaque pièce (lessivable en circulation, spécifique pièces humides). Les références retenues sont écrites dans le devis, jamais laissées au hasard.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["villepinte", "sevran", "livry-gargan", "tremblay-en-france", "chelles"],
  },
  {
    slug: "saint-denis",
    name: "Saint-Denis",
    type: "ville",
    cp: "93200",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.salon,
    title: "Rénovation d'appartement à Saint-Denis (93200) | RAMA DÉCO",
    description:
      "Travaux intérieurs à Saint-Denis : rénovation d'appartement, peinture, sols, salle de bains, cloisons. Entreprise du 93, devis gratuit et estimation immédiate.",
    h1: "Rénovation d'appartement à Saint-Denis",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "Saint-Denis mêle immeubles anciens du centre-ville, grands ensembles et quartiers récemment livrés autour de la Plaine. Nous y rénovons surtout des appartements : investisseurs, primo-accédants et copropriétaires qui remettent un bien à niveau.",
      "Dans l'ancien du centre, les points de vigilance sont récurrents : humidité de surface, plâtres dégradés, électricité vétuste et sols multicouches. Nous les identifions à la visite et les traitons dans l'ordre, plutôt que de recouvrir le problème.",
    ],
    contexte: [
      { t: "Appartements anciens", d: "Traitement des supports dégradés, reprise de plâtre, peinture, sols et remise à niveau électrique intérieure." },
      { t: "Investissement locatif", d: "Chantier calibré et daté, budget maîtrisé, photos avant/après et facture conforme pour la gestion." },
      { t: "Quartiers neufs de la Plaine", d: "Finitions de second œuvre, faïence, peinture, sols et levée de réserves." },
    ],
    typologies: ["Appartement ancien", "Investissement locatif", "Logement neuf", "Copropriété"],
    delai: "Visite sous 3 à 5 jours ouvrés",
    faq: [
      {
        q: "Traitez-vous les problèmes d'humidité dans les appartements anciens ?",
        a: "Nous traitons les désordres de surface : dépose des revêtements atteints, assainissement et préparation du support, enduits et peintures adaptés aux pièces humides, amélioration de la ventilation. Les causes structurelles (infiltrations en façade, remontées capillaires en fondation) relèvent d'une autre spécialité et nous vous orientons.",
      },
      {
        q: "Faites-vous des chantiers pour des investisseurs à distance ?",
        a: "Oui. Vous suivez l'avancement depuis votre espace projet en ligne : phases, photos, devis, factures et messages. Beaucoup de nos clients investisseurs ne se déplacent qu'une fois, à la réception.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["paris", "aubervilliers", "le-bourget", "bobigny", "pantin"],
  },
  {
    slug: "montreuil",
    name: "Montreuil",
    type: "ville",
    cp: "93100",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.parisien,
    title: "Rénovation intérieure à Montreuil (93100) | RAMA DÉCO",
    description:
      "Entreprise de rénovation à Montreuil : appartements, ateliers, maisons de ville. Peinture, parquet, salle de bains, cloisons, électricité. Devis gratuit.",
    h1: "Rénovation intérieure à Montreuil",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "Montreuil a un parc immobilier singulier : maisons de ville étroites, anciens ateliers reconvertis en lofts, immeubles de rapport du bas Montreuil et petites copropriétés autour de Croix-de-Chavaux. Chaque typologie demande une approche différente.",
      "Dans les volumes atypiques, l'enjeu est le traitement des grandes hauteurs et des surfaces brutes : plafonds hauts, verrières intérieures, murs à préparer soigneusement. Nous adaptons échafaudages, préparation et finitions à ces contraintes.",
    ],
    contexte: [
      { t: "Lofts et anciens ateliers", d: "Grandes hauteurs, cloisons partielles non porteuses, mezzanines finies, peinture de grandes surfaces." },
      { t: "Maisons de ville", d: "Rénovation intégrale sur plusieurs niveaux, escaliers intérieurs, pièces d'eau, sols continus." },
      { t: "Petites copropriétés", d: "Rafraîchissement, salle de bains compacte, cuisine, électricité intérieure aux normes." },
    ],
    typologies: ["Loft / atelier", "Maison de ville", "Appartement en copropriété", "Studio"],
    delai: "Visite sous 4 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous intervenir dans un loft à grande hauteur ?",
        a: "Oui. Nous mettons en place les moyens d'accès adaptés (échafaudage roulant, plateforme) et traitons les grandes surfaces avec une préparation renforcée, indispensable pour un rendu net sous éclairage rasant.",
      },
      {
        q: "Réalisez-vous la pose de verrières intérieures ?",
        a: "Nous réalisons l'ensemble des travaux d'accompagnement : cloison support non porteuse, réservation, plâtrerie, finitions et raccords. La menuiserie métallique est fournie et posée par un partenaire spécialisé, coordonné par nos équipes.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["paris", "bobigny", "noisy-le-sec", "pantin", "rosny-sous-bois"],
  },
  {
    slug: "pantin",
    name: "Pantin",
    type: "ville",
    cp: "93500",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.chambre,
    title: "Travaux de rénovation à Pantin (93500) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Pantin : appartements, bureaux, commerces. Peinture, cloisons, sols, salle de bains, électricité intérieure. Devis gratuit sous 48 h.",
    h1: "Rénovation intérieure à Pantin",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "Pantin attire une clientèle exigeante sur les finitions : appartements rénovés aux Grands Moulins, immeubles anciens de l'Église, boutiques et bureaux le long du canal. Le rendu final compte autant que le respect du budget.",
      "Nous répondons à cette exigence par la préparation : plus de temps passé sur les supports, moins de reprises à la fin. Un mur bien enduit et bien poncé reste beau des années ; une couche de peinture posée trop vite se voit dès la première lumière du matin.",
    ],
    contexte: [
      { t: "Finitions haut de gamme", d: "Enduits soignés, ponçage lumière rasante, teintes sur mesure, angles nets et raccords invisibles." },
      { t: "Commerces et bureaux", d: "Aménagement intérieur, cloisons, faux plafonds, sols, peinture, travaux nocturnes possibles." },
      { t: "Appartements en copropriété", d: "Rafraîchissement complet, pièces d'eau, sols et électricité intérieure." },
    ],
    typologies: ["Appartement", "Boutique / commerce", "Bureaux", "Immeuble ancien"],
    delai: "Visite sous 48 à 72 h",
    faq: [
      {
        q: "Pouvez-vous travailler la nuit pour un commerce à Pantin ?",
        a: "Oui, sur demande et dans le respect des règles locales. Les interventions nocturnes ou dominicales permettent de rénover une boutique sans fermer, avec remise en état de vente chaque matin.",
      },
      {
        q: "Proposez-vous des teintes personnalisées ?",
        a: "Oui. Nous réalisons des échantillons sur site, en lumière réelle, avant de valider la teinte. Les références exactes sont ensuite consignées dans le devis et dans le dossier de fin de chantier.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["paris", "bobigny", "montreuil", "aubervilliers", "noisy-le-sec"],
  },
  {
    slug: "aubervilliers",
    name: "Aubervilliers",
    type: "ville",
    cp: "93300",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.chantier,
    title: "Rénovation appartement & local à Aubervilliers (93300) | RAMA DÉCO",
    description:
      "Entreprise de travaux intérieurs à Aubervilliers : rénovation d'appartement, local commercial, peinture, sols, cloisons, plomberie. Devis gratuit.",
    h1: "Rénovation intérieure à Aubervilliers",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "À Aubervilliers, nous intervenons autant sur des appartements que sur des locaux d'activité et des entrepôts reconvertis en espaces de travail. Les surfaces sont souvent grandes et les supports bruts : la préparation représente une part importante du chantier.",
      "Nous chiffrons toujours la préparation séparément de la finition. C'est plus honnête et cela vous permet de comprendre pourquoi deux devis peuvent afficher des montants très différents pour « la même peinture ».",
    ],
    contexte: [
      { t: "Grandes surfaces", d: "Préparation des supports bruts, enduits, peinture au rouleau ou à l'airless, sols techniques." },
      { t: "Locaux reconvertis", d: "Cloisonnement non porteur, faux plafonds, réseaux électriques intérieurs, sanitaires." },
      { t: "Logements à rénover", d: "Peinture, sols, pièces d'eau, cuisine, remise à niveau électrique intérieure." },
    ],
    typologies: ["Appartement", "Local d'activité", "Espace de travail", "Immeuble de rapport"],
    delai: "Visite sous 4 jours ouvrés",
    faq: [
      {
        q: "Pourquoi les devis peinture varient-ils autant d'une entreprise à l'autre ?",
        a: "Parce que la préparation n'est pas toujours chiffrée. Un lessivage, un rebouchage, un enduit de lissage complet et un ponçage n'ont rien à voir avec une simple mise en peinture. Nos devis détaillent chaque opération pour rendre la comparaison possible.",
      },
      {
        q: "Intervenez-vous sur de grandes surfaces à Aubervilliers ?",
        a: "Oui, jusqu'à plusieurs centaines de m². Nous adaptons les moyens (airless, échafaudages, équipes renforcées) et le planning est établi par zones pour limiter l'immobilisation des lieux.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["saint-denis", "pantin", "paris", "le-bourget", "bobigny"],
  },
  {
    slug: "noisy-le-sec",
    name: "Noisy-le-Sec",
    type: "ville",
    cp: "93130",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.sol,
    title: "Rénovation intérieure à Noisy-le-Sec (93130) | RAMA DÉCO",
    description:
      "Travaux intérieurs à Noisy-le-Sec : peinture, sols, placo, salle de bains, cuisine, électricité. Entreprise de rénovation du 93, devis gratuit.",
    h1: "Rénovation intérieure à Noisy-le-Sec",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "Noisy-le-Sec compte beaucoup de pavillons et de petites copropriétés construites entre 1930 et 1975. Nos clients y engagent le plus souvent une rénovation par étapes, étalée sur un ou deux ans, en commençant par les pièces d'eau et les sols.",
      "Nous savons travailler ainsi : un devis global pour visualiser le budget total, puis des tranches indépendantes que vous déclenchez à votre rythme, avec des prix maintenus pendant toute la durée annoncée dans le devis.",
    ],
    contexte: [
      { t: "Rénovation par tranches", d: "Devis global puis phases indépendantes, prix tenus, planning ajusté à votre budget." },
      { t: "Pavillons d'avant-guerre", d: "Plâtres à reprendre, planchers bois, sols multicouches, électricité intérieure vétuste." },
      { t: "Petites copropriétés", d: "Rafraîchissement complet, salle d'eau, cuisine, remise en état avant emménagement." },
    ],
    typologies: ["Pavillon ancien", "Appartement", "Maison de ville", "Rénovation étalée"],
    delai: "Visite sous 72 h",
    faq: [
      {
        q: "Peut-on étaler les travaux sur plusieurs années ?",
        a: "Oui. Nous établissons un devis global découpé en tranches. Chaque tranche est engagée quand vous le décidez, avec les prix maintenus sur la durée indiquée au devis, et une facturation à l'avancement réel.",
      },
      {
        q: "Par quoi commencer une rénovation intérieure ?",
        a: "Par ce qui salit et ce qui traverse les murs : dépose, réseaux, plomberie et électricité, puis plâtrerie, puis sols et peinture. Inverser cet ordre coûte toujours plus cher, car il faut reprendre des finitions déjà réalisées.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["bobigny", "montreuil", "rosny-sous-bois", "pantin", "livry-gargan"],
  },
  {
    slug: "rosny-sous-bois",
    name: "Rosny-sous-Bois",
    type: "ville",
    cp: "93110",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.cuisine,
    title: "Entreprise de rénovation à Rosny-sous-Bois (93110) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Rosny-sous-Bois : cuisine, salle de bains, peinture, sols, cloisons. Devis gratuit, estimation en ligne immédiate, entreprise du 93.",
    h1: "Rénovation intérieure à Rosny-sous-Bois",
    kicker: "Seine-Saint-Denis · 93",
    intro: [
      "À Rosny-sous-Bois, nos chantiers sont majoritairement des rénovations familiales : agrandir visuellement un séjour, refaire une cuisine devenue trop petite, créer une seconde salle d'eau pour des adolescents ou transformer un garage en pièce de vie.",
      "Ce sont des projets où l'usage compte plus que le style : circulation, rangements, éclairage, points d'eau bien placés. Nous en discutons pendant la visite avant de proposer un chiffrage, car une bonne rénovation se joue d'abord sur le plan.",
    ],
    contexte: [
      { t: "Cuisines familiales", d: "Réseaux déplacés, sol continu, crédence, éclairage sous meubles, coordination avec le cuisiniste." },
      { t: "Seconde salle d'eau", d: "Création complète : cloison non porteuse, alimentation, évacuation, ventilation, étanchéité, faïence." },
      { t: "Pièces transformées", d: "Garage ou véranda transformés en pièce de vie : doublages, sols, électricité, chauffage électrique." },
    ],
    typologies: ["Maison familiale", "Pavillon", "Appartement", "Extension à finir"],
    delai: "Visite sous 72 h",
    faq: [
      {
        q: "Peut-on créer une salle d'eau supplémentaire dans une maison ?",
        a: "Oui, dès lors qu'un raccordement d'évacuation est atteignable dans des pentes acceptables. Nous le vérifions à la visite, puis nous réalisons cloison, réseaux, ventilation, étanchéité et finitions.",
      },
      {
        q: "Transformez-vous un garage en pièce habitable ?",
        a: "Nous réalisons tout l'intérieur : doublages isolants, cloisons, plafond, sol, électricité et chauffage. Les modifications d'ouverture en mur porteur ou de structure ne relèvent pas de notre périmètre.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["montreuil", "noisy-le-sec", "bobigny", "chelles", "paris"],
  },
  {
    slug: "mitry-mory",
    name: "Mitry-Mory",
    type: "ville",
    cp: "77290",
    dept: "Seine-et-Marne (77)",
    img: IMG.peinture,
    title: "Rénovation & travaux intérieurs à Mitry-Mory (77290) | RAMA DÉCO",
    description:
      "Entreprise de rénovation intérieure à Mitry-Mory : peinture, placo, sols, salle de bains, électricité. Devis gratuit, intervention rapide depuis Villepinte.",
    h1: "Travaux intérieurs à Mitry-Mory",
    kicker: "Seine-et-Marne · limitrophe du 93",
    intro: [
      "Mitry-Mory est directement voisine de Villepinte et Tremblay : nos équipes y sont en quinze minutes. Nous y rénovons surtout des maisons individuelles et des logements proches de la gare de Mitry-Claye.",
      "La commune compte beaucoup de propriétaires de longue durée, avec des logements bien entretenus mais datés. Les projets portent alors sur la modernisation : sols, peintures claires, éclairages encastrés, salle de bains repensée pour vieillir sereinement chez soi.",
    ],
    contexte: [
      { t: "Modernisation de l'existant", d: "Teintes claires, sols contemporains, faux plafonds avec spots, portes intérieures remplacées." },
      { t: "Salle de bains accessible", d: "Douche de plain-pied, receveur extra-plat, barre d'appui, sol antidérapant, éclairage renforcé." },
      { t: "Maisons individuelles", d: "Chantier global ou par lots, planning ferme, un seul interlocuteur du devis à la réception." },
    ],
    typologies: ["Maison individuelle", "Pavillon", "Appartement", "Rénovation senior"],
    delai: "Visite sous 48 à 72 h",
    faq: [
      {
        q: "Réalisez-vous des salles de bains adaptées au maintien à domicile ?",
        a: "Oui : douche de plain-pied ou receveur extra-plat, sol antidérapant, barres d'appui fixées dans un support renforcé, WC surélevé, éclairage sans zone d'ombre. Ces aménagements se combinent avec une finition soignée.",
      },
      {
        q: "Intervenez-vous en Seine-et-Marne malgré votre siège dans le 93 ?",
        a: "Oui, sur tout le nord de la Seine-et-Marne. Mitry-Mory est à quinze minutes de nos bureaux : le déplacement et le devis restent gratuits, sans majoration de zone.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["tremblay-en-france", "villepinte", "chelles", "roissy-en-france", "sevran"],
  },
  {
    slug: "chelles",
    name: "Chelles",
    type: "ville",
    cp: "77500",
    dept: "Seine-et-Marne (77)",
    img: IMG.salon,
    title: "Rénovation de maison à Chelles (77500) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Chelles : maison, appartement, peinture, sols, salle de bains, cuisine, placo. Devis gratuit et estimation en ligne en 5 minutes.",
    h1: "Rénovation intérieure à Chelles",
    kicker: "Seine-et-Marne · 77",
    intro: [
      "Chelles est l'une des plus grandes communes de Seine-et-Marne, avec un parc immobilier large : pavillons de la Cité Gambetta, maisons du centre, résidences du Mont-Chalâts et programmes neufs près de la gare.",
      "Nous y menons régulièrement des rénovations complètes après acquisition : trois à six semaines de travaux entre la signature et l'emménagement, avec un planning tenu, parce qu'un déménagement ne se décale pas.",
    ],
    contexte: [
      { t: "Rénovation avant emménagement", d: "Planning serré et tenu : dépose, réseaux, plâtrerie, sols, peinture, pièces d'eau, nettoyage de livraison." },
      { t: "Pavillons à moderniser", d: "Sols, peintures, salle de bains, cuisine, faux plafonds et électricité intérieure." },
      { t: "Appartements en résidence", d: "Rafraîchissement complet, respect des horaires de copropriété, protections des communs." },
    ],
    typologies: ["Maison", "Pavillon", "Appartement", "Achat à rénover"],
    delai: "Visite sous 3 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous terminer avant la date de mon déménagement ?",
        a: "C'est un engagement que nous prenons par écrit dans le devis quand le délai est réaliste. Nous refusons plutôt un chantier que de promettre une date intenable : le planning est calculé poste par poste, temps de séchage inclus.",
      },
      {
        q: "Quel est le déroulé d'une rénovation de maison à Chelles ?",
        a: "Après la visite technique, nous remettons un devis détaillé et un planning daté. Le chantier suit toujours le même ordre : dépose, réseaux, plâtrerie, sols, pièces d'eau, peinture et finitions, avec un nettoyage de livraison avant la réception.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["vaujours", "mitry-mory", "rosny-sous-bois", "livry-gargan", "villepinte"],
  },
  {
    slug: "roissy-en-france",
    name: "Roissy-en-France",
    type: "ville",
    cp: "95700",
    dept: "Val-d'Oise (95)",
    img: IMG.neuf,
    title: "Travaux intérieurs & tertiaires à Roissy-en-France (95700) | RAMA DÉCO",
    description:
      "Rénovation intérieure et aménagement de locaux à Roissy-en-France : cloisons, faux plafonds, peinture, sols, sanitaires. Devis gratuit, chantiers en site occupé.",
    h1: "Rénovation et aménagement à Roissy-en-France",
    kicker: "Val-d'Oise · zone aéroportuaire",
    intro: [
      "Roissy-en-France est un territoire d'activité : hôtels, bureaux, plateformes logistiques et logements de personnel. Nos interventions y sont souvent tertiaires, avec des exigences fortes de délai, de sécurité et de propreté.",
      "Nous savons travailler sous contrainte : plan de prévention, badges d'accès, interventions de nuit ou de week-end, phasage chambre par chambre pour un hôtel. Le devis intègre ces contraintes dès le départ, pas en cours de chantier.",
    ],
    contexte: [
      { t: "Hôtellerie", d: "Rénovation chambre par chambre : peinture, sols, salle de bains, menuiseries intérieures, sans fermer l'établissement." },
      { t: "Bureaux et plateformes", d: "Cloisonnement, faux plafonds, sols techniques, peinture, sanitaires, éclairage." },
      { t: "Logements du secteur", d: "Rafraîchissement et remise en état locative, chantiers courts et datés." },
    ],
    typologies: ["Hôtel", "Bureaux", "Local logistique", "Logement locatif"],
    delai: "Visite sous 3 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous rénover un hôtel sans le fermer ?",
        a: "Oui, en travaillant par lots de chambres avec un planning de rotation. Chaque chambre est rendue exploitable à la fin de son cycle de travaux, les circulations restent propres et sécurisées pour la clientèle.",
      },
      {
        q: "Gérez-vous les contraintes d'accès en zone aéroportuaire ?",
        a: "Oui : plan de prévention, listes nominatives, badges, horaires imposés et consignes de sécurité site. Ces sujets sont traités avant le démarrage, avec un interlocuteur unique côté RAMA DÉCO.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["tremblay-en-france", "gonesse", "goussainville", "villepinte", "mitry-mory"],
  },
  {
    slug: "gonesse",
    name: "Gonesse",
    type: "ville",
    cp: "95500",
    dept: "Val-d'Oise (95)",
    img: IMG.sdb,
    title: "Rénovation intérieure à Gonesse (95500) | RAMA DÉCO",
    description:
      "Entreprise de travaux intérieurs à Gonesse : peinture, sols, salle de bains, placo, électricité. Devis gratuit et estimation en ligne, intervention dans le 95.",
    h1: "Rénovation intérieure à Gonesse",
    kicker: "Val-d'Oise · 95",
    intro: [
      "Gonesse est à quinze minutes de nos bureaux par la Francilienne. Nous y rénovons des pavillons du centre ancien, des logements de la Fauconnière et des locaux professionnels proches de l'hôpital.",
      "Les demandes portent souvent sur la salle de bains et sur l'électricité intérieure : beaucoup de logements conservent des installations d'origine, avec des tableaux sans différentiel adapté et des pièces d'eau sans liaison équipotentielle.",
    ],
    contexte: [
      { t: "Électricité intérieure", d: "Tableau remis à niveau, circuits séparés, prises et points lumineux ajoutés, liaison équipotentielle en pièce d'eau." },
      { t: "Salle de bains complète", d: "Dépose, réseaux, étanchéité, carrelage, sanitaires, meuble, ventilation et éclairage." },
      { t: "Rafraîchissement global", d: "Peinture, sols, plinthes, portes intérieures pour un rendu homogène." },
    ],
    typologies: ["Pavillon", "Appartement", "Local professionnel", "Logement locatif"],
    delai: "Visite sous 72 h",
    faq: [
      {
        q: "Faites-vous la mise aux normes électriques ?",
        a: "Nous réalisons la mise à niveau de l'installation intérieure : tableau, circuits, protections différentielles, prises, points lumineux et liaison équipotentielle des pièces d'eau. Les travaux sur le branchement concessionnaire restent du ressort du distributeur.",
      },
      {
        q: "Intervenez-vous dans tout le Val-d'Oise ?",
        a: "Nous couvrons l'est du Val-d'Oise en priorité : Gonesse, Goussainville, Roissy, Villiers-le-Bel, Sarcelles, Arnouville. Le déplacement et le devis sont gratuits sur toute cette zone.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["goussainville", "roissy-en-france", "villepinte", "le-blanc-mesnil", "tremblay-en-france"],
  },
  {
    slug: "goussainville",
    name: "Goussainville",
    type: "ville",
    cp: "95190",
    dept: "Val-d'Oise (95)",
    img: IMG.chambre,
    title: "Travaux de rénovation à Goussainville (95190) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Goussainville : peinture, sols, cloisons, salle de bains, cuisine. Entreprise sérieuse, devis gratuit et planning ferme.",
    h1: "Rénovation intérieure à Goussainville",
    kicker: "Val-d'Oise · 95",
    intro: [
      "À Goussainville, nous intervenons principalement sur des maisons individuelles et des logements en résidence. Une grande partie de nos chantiers y démarre après une simple estimation en ligne, suivie d'une visite technique de confirmation.",
      "Nous rencontrons souvent des logements dont les pièces ont été rénovées à des époques différentes, avec des niveaux de sol et des teintes hétérogènes. Notre travail consiste alors à retrouver une cohérence : sol continu, teintes maîtrisées, menuiseries intérieures uniformisées.",
    ],
    contexte: [
      { t: "Remise en cohérence", d: "Sols continus, niveaux repris au ragréage, teintes harmonisées, portes et plinthes uniformisées." },
      { t: "Pièces d'eau", d: "Salle de bains et WC entièrement refaits, ventilation traitée, étanchéité conforme." },
      { t: "Confort thermique et phonique", d: "Doublages intérieurs isolants sur murs froids, traitement des plafonds entre logements." },
    ],
    typologies: ["Maison individuelle", "Appartement", "Logement locatif", "Rénovation partielle"],
    delai: "Visite sous 72 h",
    faq: [
      {
        q: "L'estimation en ligne est-elle fiable ?",
        a: "Elle donne une fourchette réaliste, calculée à partir de nos prix réels et du détail de votre description. Elle n'engage pas : le devis ferme est établi après la visite technique, quand les surfaces et l'état des supports sont mesurés.",
      },
      {
        q: "Peut-on obtenir un sol identique dans toutes les pièces ?",
        a: "Oui, c'est même l'un des gestes qui transforment le plus un logement. Cela demande de reprendre les différences de niveau au ragréage et de traiter les seuils, ce que nous chiffrons explicitement.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["gonesse", "roissy-en-france", "villepinte", "tremblay-en-france", "le-blanc-mesnil"],
  },
  {
    slug: "seine-saint-denis",
    name: "Seine-Saint-Denis",
    type: "departement",
    cp: "93",
    dept: "Seine-Saint-Denis (93)",
    img: IMG.chantier,
    title: "Entreprise de rénovation en Seine-Saint-Denis (93) | RAMA DÉCO",
    description:
      "RAMA DÉCO, entreprise de travaux intérieurs et de rénovation en Seine-Saint-Denis : peinture, placo, sols, salles de bains, second œuvre. Devis gratuit dans tout le 93.",
    h1: "Entreprise de rénovation en Seine-Saint-Denis",
    kicker: "Département 93 · notre territoire",
    intro: [
      "RAMA DÉCO est une entreprise séquano-dionysienne : basée à Villepinte, nous réalisons la majorité de nos chantiers dans le département. Cela nous donne une connaissance concrète du bâti local, des pavillons meulières aux grands ensembles des années 60, jusqu'aux programmes neufs des dernières années.",
      "Cette proximité a un effet direct sur le prix : moins de temps de transport, pas de frais de zone, une logistique matériel courte. Et un effet sur le service : nous revenons sans discuter si une finition doit être reprise après la réception.",
    ],
    contexte: [
      { t: "Toutes les communes du 93", d: "De Villepinte à Montreuil, de Saint-Denis à Chelles : déplacement et devis gratuits partout dans le département." },
      { t: "Tous corps d'état intérieurs", d: "Peinture, plâtrerie, sols, électricité, plomberie, pièces d'eau, menuiserie intérieure : un seul interlocuteur." },
      { t: "Particuliers et professionnels", d: "Propriétaires, bailleurs, syndics, commerces, bureaux et promoteurs pour les lots de second œuvre." },
    ],
    typologies: ["Pavillon", "Appartement", "Local professionnel", "Logement neuf"],
    delai: "Visite technique sous 48 à 96 h selon la commune",
    faq: [
      {
        q: "Dans quelles villes du 93 intervenez-vous ?",
        a: "Dans tout le département : Villepinte, Aulnay-sous-Bois, Tremblay-en-France, Sevran, Le Blanc-Mesnil, Drancy, Bobigny, Le Bourget, Livry-Gargan, Saint-Denis, Aubervilliers, Pantin, Montreuil, Noisy-le-Sec, Rosny-sous-Bois, Vaujours et les communes voisines.",
      },
      {
        q: "Vos prix varient-ils selon la commune ?",
        a: "Non, nos prix unitaires sont identiques dans tout le département. Seules les contraintes réelles de chantier peuvent faire varier un devis : accès, étage sans ascenseur, stationnement, évacuation, horaires imposés.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["villepinte", "aulnay-sous-bois", "saint-denis", "montreuil", "bobigny", "paris"],
  },
  {
    slug: "val-d-oise",
    name: "Val-d'Oise",
    type: "departement",
    cp: "95",
    dept: "Val-d'Oise (95)",
    img: IMG.sejour,
    title: "Entreprise de rénovation dans le Val-d'Oise (95) | RAMA DÉCO",
    description:
      "Travaux intérieurs et rénovation dans le Val-d'Oise : Gonesse, Goussainville, Roissy, Sarcelles, Villiers-le-Bel. Devis gratuit, entreprise tous corps d'état intérieurs.",
    h1: "Rénovation et travaux intérieurs dans le Val-d'Oise",
    kicker: "Département 95",
    intro: [
      "Le Val-d'Oise est notre deuxième territoire d'intervention, en particulier sa partie est : Gonesse, Goussainville, Roissy-en-France, Villiers-le-Bel, Arnouville, Sarcelles et Garges-lès-Gonesse, toutes accessibles en moins de trente minutes depuis Villepinte.",
      "Nous y traitons beaucoup de maisons individuelles, avec des projets de modernisation complète, ainsi que des locaux professionnels autour de la plateforme aéroportuaire. Le fonctionnement est identique à celui du 93 : devis détaillé, planning ferme, suivi en ligne.",
    ],
    contexte: [
      { t: "Est du Val-d'Oise", d: "Gonesse, Goussainville, Roissy, Villiers-le-Bel, Arnouville, Sarcelles, Garges-lès-Gonesse." },
      { t: "Maisons individuelles", d: "Rénovation intérieure complète ou par lots, pièces d'eau, sols, peinture, électricité intérieure." },
      { t: "Tertiaire et hôtellerie", d: "Aménagement de bureaux, rénovation de chambres, chantiers en site occupé." },
    ],
    typologies: ["Maison", "Appartement", "Hôtel", "Bureaux"],
    delai: "Visite sous 3 à 5 jours ouvrés",
    faq: [
      {
        q: "Quelles communes du 95 couvrez-vous ?",
        a: "Principalement l'est du département : Gonesse, Goussainville, Roissy-en-France, Villiers-le-Bel, Arnouville, Sarcelles, Garges-lès-Gonesse, Le Thillay, Bonneuil-en-France. Pour les autres communes, contactez-nous : nous étudions la faisabilité au cas par cas.",
      },
      {
        q: "Le déplacement est-il facturé dans le Val-d'Oise ?",
        a: "Non, le déplacement pour la visite technique et l'établissement du devis est gratuit, sans condition de montant de travaux.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["gonesse", "goussainville", "roissy-en-france", "seine-saint-denis", "ile-de-france"],
  },
  {
    slug: "seine-et-marne",
    name: "Seine-et-Marne",
    type: "departement",
    cp: "77",
    dept: "Seine-et-Marne (77)",
    img: IMG.peinture,
    title: "Entreprise de rénovation en Seine-et-Marne (77) | RAMA DÉCO",
    description:
      "Rénovation intérieure en Seine-et-Marne : Chelles, Mitry-Mory, Claye-Souilly, Villeparisis. Peinture, sols, placo, salle de bains. Devis gratuit.",
    h1: "Rénovation intérieure en Seine-et-Marne",
    kicker: "Département 77 · nord-ouest",
    intro: [
      "Nous intervenons sur le nord-ouest de la Seine-et-Marne, la partie du département la plus proche de nos bureaux : Chelles, Mitry-Mory, Villeparisis, Claye-Souilly, Vaires-sur-Marne, Le Pin et Courtry.",
      "Le bâti y est majoritairement pavillonnaire, avec de belles surfaces et des projets souvent globaux. Nos clients cherchent une entreprise capable de coordonner tous les métiers intérieurs sans multiplier les artisans et les rendez-vous.",
    ],
    contexte: [
      { t: "Nord-ouest du 77", d: "Chelles, Mitry-Mory, Villeparisis, Claye-Souilly, Vaires-sur-Marne, Courtry, Le Pin." },
      { t: "Rénovation globale de maison", d: "Tous les lots intérieurs coordonnés : plâtrerie, sols, peinture, électricité, plomberie, pièces d'eau." },
      { t: "Un seul interlocuteur", d: "Un conducteur de travaux dédié, un planning unique, un devis consolidé, une facturation à l'avancement." },
    ],
    typologies: ["Maison individuelle", "Pavillon", "Appartement", "Achat à rénover"],
    delai: "Visite sous 3 à 5 jours ouvrés",
    faq: [
      {
        q: "Quelles villes de Seine-et-Marne desservez-vous ?",
        a: "Le nord-ouest du département : Chelles, Mitry-Mory, Villeparisis, Claye-Souilly, Vaires-sur-Marne, Courtry, Le Pin, Brou-sur-Chantereine. Au-delà, nous étudions chaque demande selon la nature et la durée du chantier.",
      },
      {
        q: "Coordonnez-vous tous les métiers d'une rénovation complète ?",
        a: "Oui, pour l'ensemble des lots intérieurs : nos équipes réalisent l'essentiel, et les rares spécialités externes sont pilotées par notre conducteur de travaux. Vous n'avez qu'un contact, un planning et un devis.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["chelles", "mitry-mory", "vaujours", "seine-saint-denis", "ile-de-france"],
  },
  {
    slug: "ile-de-france",
    name: "Île-de-France",
    type: "region",
    cp: "IDF",
    dept: "Île-de-France",
    img: IMG.salon,
    title: "Entreprise de rénovation intérieure en Île-de-France | RAMA DÉCO",
    description:
      "RAMA DÉCO, entreprise de travaux intérieurs, rénovation et second œuvre en Île-de-France. Paris, 93, 95, 77 : devis gratuit et estimation en ligne en 5 minutes.",
    h1: "Entreprise de rénovation intérieure en Île-de-France",
    kicker: "Paris · 93 · 95 · 77",
    intro: [
      "RAMA DÉCO intervient dans toute l'Île-de-France pour les travaux intérieurs, la rénovation et le second œuvre : Paris et les huit départements de la région, sans restriction de zone. Notre implantation à Villepinte nous place au centre d'un triangle Paris – Roissy – Marne-la-Vallée, avec un accès direct à l'A104, l'A3, l'A1 et la N2.",
      "Que votre projet soit un studio parisien, un pavillon en Seine-Saint-Denis, une maison dans les Yvelines, un appartement dans les Hauts-de-Seine ou un plateau de bureaux dans le Val-d'Oise, la méthode est la même : une première estimation en ligne, une visite technique gratuite, un devis détaillé poste par poste, un planning ferme et un espace en ligne pour suivre l'avancement.",
    ],
    contexte: [
      { t: "Les 8 départements couverts", d: "Paris (75), Seine-et-Marne (77), Yvelines (78), Essonne (91), Hauts-de-Seine (92), Seine-Saint-Denis (93), Val-de-Marne (94), Val-d'Oise (95)." },
      { t: "Estimation immédiate", d: "Décrivez votre projet avec vos mots : vous obtenez une première évaluation détaillée en cinq minutes." },
      { t: "Suivi en ligne", d: "Espace projet client : phases du chantier, photos, devis, factures, messages et documents." },
    ],
    typologies: ["Appartement", "Maison", "Local professionnel", "Logement neuf"],
    delai: "Visite technique sous 48 h à 5 jours selon la zone",
    faq: [
      {
        q: "Jusqu'où vous déplacez-vous en Île-de-France ?",
        a: "Partout : Paris, la Seine-Saint-Denis, le Val-d'Oise, la Seine-et-Marne, les Hauts-de-Seine, le Val-de-Marne, les Yvelines et l'Essonne. Le déplacement pour la visite technique et le devis reste gratuit, sans majoration de zone.",
      },
      {
        q: "Comment obtenir une estimation sans attendre une visite ?",
        a: "Décrivez votre projet dans notre estimateur en ligne, à l'écrit ou à la voix. L'analyse identifie les lots concernés et vous renvoie une première évaluation ventilée par poste, avec le niveau de précision atteignable à ce stade.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["paris", "seine-saint-denis", "hauts-de-seine", "val-de-marne", "val-d-oise", "seine-et-marne", "yvelines", "essonne"],
  },
  {
    slug: "hauts-de-seine",
    name: "Hauts-de-Seine",
    type: "departement",
    cp: "92",
    dept: "Hauts-de-Seine (92)",
    img: IMG.parisien,
    title: "Entreprise de rénovation dans les Hauts-de-Seine (92) | RAMA DÉCO",
    description:
      "Travaux intérieurs et rénovation dans les Hauts-de-Seine : Boulogne, Nanterre, Colombes, Asnières. Peinture, parquet, salle de bains, cloisons. Devis gratuit.",
    h1: "Rénovation intérieure dans les Hauts-de-Seine",
    kicker: "Département 92",
    intro: [
      "Les Hauts-de-Seine réunissent des immeubles bourgeois de la première couronne, des programmes récents autour de La Défense et un tissu pavillonnaire dense dans les communes du nord. Les attentes en matière de finition y sont élevées, et c'est précisément le terrain sur lequel nous nous jugeons.",
      "Nos chantiers du 92 sont surtout des appartements en copropriété : redistribution de cloisons non porteuses, réfection de parquet, salle de bains repensée, cuisine ouverte quand le mur le permet. Nous y appliquons le même protocole qu'à Paris, protections des communs comprises.",
    ],
    contexte: [
      { t: "Immeubles bourgeois", d: "Plâtres traditionnels, parquets anciens, moulures : préparation soignée et finitions à la brosse dans les profils." },
      { t: "Programmes récents", d: "Finitions de second œuvre, compléments électriques, faïence, sols et levée de réserves après livraison." },
      { t: "Pavillonnaire du nord 92", d: "Rénovation intérieure complète de maisons de ville : pièces d'eau, sols, plâtrerie, électricité intérieure." },
    ],
    typologies: ["Appartement en copropriété", "Immeuble bourgeois", "Maison de ville", "Logement neuf"],
    delai: "Visite technique sous 4 à 6 jours ouvrés",
    faq: [
      {
        q: "Intervenez-vous dans les Hauts-de-Seine depuis la Seine-Saint-Denis ?",
        a: "Oui, sans majoration de zone. Nos équipes rejoignent le 92 par l'A86 et le périphérique ; la logistique matériel est planifiée la veille pour éviter les allers-retours en journée.",
      },
      {
        q: "Quelles communes du 92 couvrez-vous ?",
        a: "L'ensemble du département, avec une présence renforcée à Boulogne-Billancourt, Nanterre, Colombes, Asnières-sur-Seine, Courbevoie, Levallois, Clichy et Neuilly-sur-Seine.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["boulogne-billancourt", "nanterre", "colombes", "asnieres-sur-seine", "paris", "ile-de-france"],
  },
  {
    slug: "boulogne-billancourt",
    name: "Boulogne-Billancourt",
    type: "ville",
    cp: "92100",
    dept: "Hauts-de-Seine (92)",
    img: IMG.salon,
    title: "Rénovation d'appartement à Boulogne-Billancourt (92100) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Boulogne-Billancourt : appartements, parquet, salle de bains, cuisine, peinture haut de gamme. Devis gratuit et estimation en ligne.",
    h1: "Rénovation d'appartement à Boulogne-Billancourt",
    kicker: "Hauts-de-Seine · 92",
    intro: [
      "Boulogne-Billancourt est une ville d'appartements, avec un patrimoine architectural remarquable : immeubles Art déco, réalisations modernistes des années 30 et grands programmes du Trapèze. Chaque époque impose ses règles de finition.",
      "Dans les immeubles anciens, le soin apporté aux détails fait toute la différence : profils de moulures repris à la brosse, parquets remis en état plutôt que remplacés, teintes échantillonnées sur site avant validation. Dans le neuf, il s'agit surtout d'élever le niveau de finition livré par le promoteur.",
    ],
    contexte: [
      { t: "Immeubles Art déco et années 30", d: "Plâtres traditionnels, parquets à bâtons rompus, menuiseries intérieures d'origine à conserver." },
      { t: "Quartier du Trapèze", d: "Finitions de second œuvre après livraison : peinture, sols, faïence, compléments électriques." },
      { t: "Copropriétés exigeantes", d: "Déclaration au syndic, horaires respectés, protection intégrale des parties communes." },
    ],
    typologies: ["Appartement ancien", "Appartement neuf", "Studio", "Duplex"],
    delai: "Visite technique sous 5 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous rénover un parquet ancien sans le remplacer ?",
        a: "Oui, dans la majorité des cas : ponçage progressif, reprise des lames abîmées, puis vitrification ou huilage. C'est souvent plus beau et plus durable qu'un remplacement, et cela préserve le caractère du logement.",
      },
      {
        q: "Comment gérez-vous les contraintes de copropriété à Boulogne ?",
        a: "Nous préparons le dossier technique pour le syndic, respectons les horaires autorisés, protégeons intégralement les communs et évacuons les gravats quotidiennement. C'est ce qui permet un chantier sans conflit de voisinage.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["hauts-de-seine", "paris", "nanterre", "colombes", "asnieres-sur-seine"],
  },
  {
    slug: "nanterre",
    name: "Nanterre",
    type: "ville",
    cp: "92000",
    dept: "Hauts-de-Seine (92)",
    img: IMG.neuf,
    title: "Rénovation & second œuvre à Nanterre (92000) | RAMA DÉCO",
    description:
      "Travaux intérieurs à Nanterre : rénovation d'appartement, bureaux, second œuvre en logement neuf. Peinture, cloisons, sols, pièces d'eau. Devis gratuit.",
    h1: "Rénovation et second œuvre à Nanterre",
    kicker: "Hauts-de-Seine · 92",
    intro: [
      "Nanterre combine un centre ancien, de grands ensembles rénovés et le quartier d'affaires de La Défense à ses portes. Nos interventions y sont donc mixtes : logements en copropriété d'un côté, bureaux et locaux tertiaires de l'autre.",
      "Sur le tertiaire, nous travaillons souvent en site occupé, par zones et en horaires aménagés. Sur le résidentiel, la demande porte surtout sur la modernisation complète : cloisonnement revu, sols continus, pièces d'eau refaites et éclairage repensé.",
    ],
    contexte: [
      { t: "Tertiaire et bureaux", d: "Cloisons placo et vitrées non porteuses, faux plafonds acoustiques, sols souples, peinture, éclairage." },
      { t: "Logements collectifs", d: "Rénovation complète ou par lots, avec respect strict des horaires de copropriété." },
      { t: "Programmes neufs", d: "Second œuvre et finitions après livraison, levée de réserves documentée en photos." },
    ],
    typologies: ["Appartement", "Bureaux / tertiaire", "Logement neuf", "Local commercial"],
    delai: "Visite technique sous 4 à 6 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous rénover des bureaux sans interrompre l'activité ?",
        a: "Oui. Nous découpons le chantier en zones, travaillons en horaires décalés si nécessaire et remettons chaque espace en état d'usage à la fin de chaque intervention.",
      },
      {
        q: "Fournissez-vous les documents exigés par un bailleur professionnel ?",
        a: "Oui : Kbis, attestation de responsabilité civile professionnelle, garantie décennale et attestation de vigilance URSSAF sont transmis avec le devis, ainsi que le planning et le plan de prévention si le site l'exige.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["hauts-de-seine", "colombes", "boulogne-billancourt", "asnieres-sur-seine", "paris"],
  },
  {
    slug: "colombes",
    name: "Colombes",
    type: "ville",
    cp: "92700",
    dept: "Hauts-de-Seine (92)",
    img: IMG.chambre,
    title: "Travaux de rénovation à Colombes (92700) | RAMA DÉCO",
    description:
      "Entreprise de rénovation intérieure à Colombes : maisons de ville, appartements, peinture, sols, salle de bains, placo. Devis gratuit sous 5 jours.",
    h1: "Rénovation intérieure à Colombes",
    kicker: "Hauts-de-Seine · 92",
    intro: [
      "Colombes possède un tissu pavillonnaire dense, avec beaucoup de maisons de ville étroites construites entre 1900 et 1960, et des copropriétés plus récentes autour des gares. Les projets y sont souvent familiaux : gagner de la place, moderniser, repenser la circulation.",
      "Dans les maisons étroites, tout se joue sur l'organisation intérieure : escaliers, couloirs, points d'eau. Nous en discutons pendant la visite technique avant de proposer un chiffrage, car une bonne rénovation se décide d'abord sur le plan.",
    ],
    contexte: [
      { t: "Maisons de ville", d: "Rénovation sur plusieurs niveaux, escaliers intérieurs, sols continus, pièces d'eau compactes." },
      { t: "Copropriétés récentes", d: "Rafraîchissement complet, sols, cuisine, salle de bains, remise à niveau électrique intérieure." },
      { t: "Optimisation d'espace", d: "Cloisons non porteuses déposées ou créées, rangements intégrés, faux plafonds avec spots." },
    ],
    typologies: ["Maison de ville", "Appartement", "Pavillon", "Studio"],
    delai: "Visite technique sous 5 jours ouvrés",
    faq: [
      {
        q: "Peut-on ouvrir la cuisine sur le séjour dans une maison de ville ?",
        a: "Uniquement si la cloison concernée n'est pas porteuse — ce que nous contrôlons lors de la visite. Si le mur est porteur, le projet relève du gros œuvre et sort de notre périmètre : nous vous le disons immédiatement.",
      },
      {
        q: "Réalisez-vous des rangements sur mesure ?",
        a: "Oui, en menuiserie intérieure : placards intégrés sous escalier, niches en plâtrerie, dressings cloisonnés. Ces aménagements sont chiffrés séparément dans le devis.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["hauts-de-seine", "nanterre", "asnieres-sur-seine", "boulogne-billancourt", "paris"],
  },
  {
    slug: "asnieres-sur-seine",
    name: "Asnières-sur-Seine",
    type: "ville",
    cp: "92600",
    dept: "Hauts-de-Seine (92)",
    img: IMG.sejour,
    title: "Rénovation intérieure à Asnières-sur-Seine (92600) | RAMA DÉCO",
    description:
      "Rénovation d'appartement et de maison à Asnières-sur-Seine : peinture, parquet, salle de bains, cuisine, cloisons. Entreprise tous corps d'état intérieurs.",
    h1: "Rénovation intérieure à Asnières-sur-Seine",
    kicker: "Hauts-de-Seine · 92",
    intro: [
      "Asnières-sur-Seine attire beaucoup de jeunes propriétaires qui achètent un premier appartement à rénover. Les biens ont souvent été loués longtemps : les supports sont fatigués, l'électricité datée, la salle de bains d'origine.",
      "Ce sont des chantiers que nous connaissons bien, avec un enjeu simple : livrer avant l'emménagement. Nous établissons donc un planning ferme et nous le tenons, parce qu'un déménagement ne se décale pas.",
    ],
    contexte: [
      { t: "Premier achat à rénover", d: "Chantier complet et daté entre la signature et l'emménagement : réseaux, sols, peinture, pièce d'eau." },
      { t: "Immeubles des années 30", d: "Plâtres à reprendre, parquets à remettre en état, huisseries intérieures à repeindre." },
      { t: "Pavillons de bord de Seine", d: "Rénovation intérieure complète, doublages isolants, salle de bains et cuisine." },
    ],
    typologies: ["Appartement ancien", "Premier achat", "Pavillon", "Investissement locatif"],
    delai: "Visite technique sous 5 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous terminer avant mon emménagement ?",
        a: "C'est un engagement que nous prenons par écrit dans le devis quand le délai est réaliste. Le planning est calculé poste par poste, temps de séchage inclus : nous préférons refuser un chantier que promettre une date intenable.",
      },
      {
        q: "Faut-il refaire l'électricité d'un appartement ancien ?",
        a: "Souvent partiellement : tableau remis à niveau, protections différentielles, circuits séparés, prises et points lumineux ajoutés, liaison équipotentielle en pièce d'eau. Nous le vérifions lors de la visite et le chiffrons clairement.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["hauts-de-seine", "colombes", "nanterre", "paris", "boulogne-billancourt"],
  },
  {
    slug: "val-de-marne",
    name: "Val-de-Marne",
    type: "departement",
    cp: "94",
    dept: "Val-de-Marne (94)",
    img: IMG.sol,
    title: "Entreprise de rénovation dans le Val-de-Marne (94) | RAMA DÉCO",
    description:
      "Rénovation intérieure dans le Val-de-Marne : Créteil, Vitry, Champigny, Saint-Maur. Peinture, sols, salle de bains, cloisons, électricité. Devis gratuit.",
    h1: "Rénovation intérieure dans le Val-de-Marne",
    kicker: "Département 94",
    intro: [
      "Le Val-de-Marne est un département de contrastes : grands ensembles de Créteil et Vitry, pavillons de bord de Marne, maisons meulières de Saint-Maur et programmes neufs le long des nouvelles lignes de transport.",
      "Nous y intervenons pour des rénovations intérieures complètes comme pour des lots isolés. Le fonctionnement est le même que dans le 93 : visite technique gratuite, devis détaillé poste par poste, planning ferme et suivi de chantier en ligne.",
    ],
    contexte: [
      { t: "Grands ensembles rénovés", d: "Rafraîchissement complet, sols, pièces d'eau, remise à niveau de l'électricité intérieure." },
      { t: "Bord de Marne", d: "Pavillons et meulières : plâtrerie, doublages, sols, salle de bains, cuisine." },
      { t: "Programmes neufs", d: "Second œuvre après livraison, finitions et levée de réserves documentée." },
    ],
    typologies: ["Appartement", "Pavillon", "Meulière", "Logement neuf"],
    delai: "Visite technique sous 4 à 6 jours ouvrés",
    faq: [
      {
        q: "Quelles communes du 94 couvrez-vous ?",
        a: "L'ensemble du département, avec une présence renforcée à Créteil, Vitry-sur-Seine, Champigny-sur-Marne, Saint-Maur-des-Fossés, Maisons-Alfort, Ivry-sur-Seine, Vincennes et Nogent-sur-Marne.",
      },
      {
        q: "Le déplacement est-il facturé dans le Val-de-Marne ?",
        a: "Non. La visite technique, les conseils et le devis sont gratuits, sans condition de montant de travaux et sans majoration de zone.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["creteil", "vitry-sur-seine", "champigny-sur-marne", "saint-maur-des-fosses", "paris", "ile-de-france"],
  },
  {
    slug: "creteil",
    name: "Créteil",
    type: "ville",
    cp: "94000",
    dept: "Val-de-Marne (94)",
    img: IMG.sdb,
    title: "Rénovation d'appartement à Créteil (94000) | RAMA DÉCO",
    description:
      "Travaux intérieurs à Créteil : rénovation d'appartement, salle de bains, cuisine, peinture, sols. Entreprise tous corps d'état intérieurs, devis gratuit.",
    h1: "Rénovation d'appartement à Créteil",
    kicker: "Val-de-Marne · 94",
    intro: [
      "Créteil est une ville d'appartements, largement construite entre 1960 et 1985. Les logements y sont souvent bien conçus mais datés : cuisines fermées, salles de bains d'origine, sols collés et électricité sous-dimensionnée.",
      "Nos chantiers y suivent presque toujours le même schéma : réseaux repris, pièce d'eau entièrement refaite, sol homogène dans tout le logement et peinture complète. Le résultat transforme le bien sans toucher à sa structure.",
    ],
    contexte: [
      { t: "Appartements des années 70", d: "Sols collés à déposer, cloisons légères à revoir, réseaux et tableau électrique à remettre à niveau." },
      { t: "Pièces d'eau à refaire", d: "Salle de bains et WC entièrement rénovés, ventilation traitée, étanchéité conforme." },
      { t: "Chantiers en copropriété", d: "Horaires respectés, protections des parties communes, évacuation régulière des gravats." },
    ],
    typologies: ["Appartement en copropriété", "Investissement locatif", "Studio", "Grand T4/T5"],
    delai: "Visite technique sous 5 jours ouvrés",
    faq: [
      {
        q: "Peut-on ouvrir une cuisine fermée dans un immeuble des années 70 ?",
        a: "Souvent oui, lorsque la cloison n'est pas porteuse et que les réseaux le permettent. Nous vérifions la nature du mur et la faisabilité des déplacements d'alimentation et d'évacuation lors de la visite.",
      },
      {
        q: "Combien de temps dure la rénovation d'un T3 à Créteil ?",
        a: "Comptez 4 à 7 semaines pour une rénovation intérieure complète avec réseaux repris, salle de bains refaite, sols et peinture. Un simple rafraîchissement tient en 8 à 12 jours ouvrés.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["val-de-marne", "vitry-sur-seine", "champigny-sur-marne", "saint-maur-des-fosses", "paris"],
  },
  {
    slug: "vitry-sur-seine",
    name: "Vitry-sur-Seine",
    type: "ville",
    cp: "94400",
    dept: "Val-de-Marne (94)",
    img: IMG.peinture,
    title: "Travaux de rénovation à Vitry-sur-Seine (94400) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Vitry-sur-Seine : peinture, sols, cloisons, salle de bains, électricité. Entreprise sérieuse, devis gratuit et planning ferme.",
    h1: "Rénovation intérieure à Vitry-sur-Seine",
    kicker: "Val-de-Marne · 94",
    intro: [
      "Vitry-sur-Seine se transforme rapidement, avec de nombreuses opérations de logements neufs à côté d'un parc ancien important. Nous y intervenons aussi bien pour des finitions de livraison que pour des rénovations complètes d'appartements anciens.",
      "Beaucoup de nos clients y sont propriétaires bailleurs ou primo-accédants. Dans les deux cas, la priorité est la même : un chantier court, propre, daté précisément, et une facture détaillée poste par poste.",
    ],
    contexte: [
      { t: "Remise en état locative", d: "Peinture complète, sols, reprises de plâtre, sanitaires et robinetterie : chantier calibré et daté." },
      { t: "Logements neufs livrés", d: "Peinture de finition, sols, faïence complémentaire, compléments électriques, levée de réserves." },
      { t: "Parc ancien", d: "Réseaux repris, salle de bains refaite, sols homogènes, plâtrerie et finitions." },
    ],
    typologies: ["Appartement ancien", "Logement neuf", "Investissement locatif", "Pavillon"],
    delai: "Visite technique sous 5 jours ouvrés",
    faq: [
      {
        q: "Travaillez-vous pour les propriétaires bailleurs ?",
        a: "Oui, régulièrement. Nous fournissons un devis détaillé, un planning ferme, des photos avant/après et une facture conforme, ce qui facilite la gestion locative et la justification des travaux.",
      },
      {
        q: "Intervenez-vous après la livraison d'un logement neuf ?",
        a: "Oui : peinture de finition, sols, faïence complémentaire, portes et plinthes, compléments électriques, et reprise des réserves constatées au procès-verbal.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["val-de-marne", "creteil", "paris", "champigny-sur-marne", "saint-maur-des-fosses"],
  },
  {
    slug: "champigny-sur-marne",
    name: "Champigny-sur-Marne",
    type: "ville",
    cp: "94500",
    dept: "Val-de-Marne (94)",
    img: IMG.cuisine,
    title: "Rénovation de maison à Champigny-sur-Marne (94500) | RAMA DÉCO",
    description:
      "Rénovation intérieure de maison à Champigny-sur-Marne : cuisine, salle de bains, peinture, sols, placo, électricité. Devis gratuit et planning ferme.",
    h1: "Rénovation de maison à Champigny-sur-Marne",
    kicker: "Val-de-Marne · 94",
    intro: [
      "Champigny-sur-Marne est une commune très pavillonnaire, avec beaucoup de maisons construites entre les années 30 et 70 et souvent agrandies au fil du temps. Ces extensions successives créent des niveaux de sol différents et des teintes hétérogènes d'une pièce à l'autre.",
      "Notre travail consiste alors à retrouver une cohérence d'ensemble : sol continu, niveaux repris au ragréage, teintes maîtrisées, menuiseries intérieures uniformisées. C'est le geste qui transforme le plus une maison, souvent plus que la démolition d'une cloison.",
    ],
    contexte: [
      { t: "Maisons agrandies", d: "Reprise des différences de niveau, sols continus, harmonisation des teintes et des menuiseries." },
      { t: "Cuisines familiales", d: "Réseaux déplacés, crédence, sol, éclairage sous meubles, coordination avec le cuisiniste." },
      { t: "Rénovation par phases", d: "Devis global puis tranches indépendantes, déclenchées à votre rythme, prix tenus." },
    ],
    typologies: ["Pavillon", "Maison agrandie", "Appartement", "Combles aménagés"],
    delai: "Visite technique sous 5 jours ouvrés",
    faq: [
      {
        q: "Peut-on obtenir le même sol dans toute la maison ?",
        a: "Oui, c'est même l'un des gestes qui transforment le plus un logement. Cela demande de reprendre les différences de niveau au ragréage et de traiter les seuils, ce que nous chiffrons explicitement.",
      },
      {
        q: "Peut-on étaler les travaux sur plusieurs années ?",
        a: "Oui. Nous établissons un devis global découpé en tranches. Chaque tranche est engagée quand vous le décidez, avec les prix maintenus sur la durée indiquée au devis.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["val-de-marne", "saint-maur-des-fosses", "creteil", "vitry-sur-seine", "chelles"],
  },
  {
    slug: "saint-maur-des-fosses",
    name: "Saint-Maur-des-Fossés",
    type: "ville",
    cp: "94100",
    dept: "Val-de-Marne (94)",
    img: IMG.salon,
    title: "Rénovation intérieure à Saint-Maur-des-Fossés (94100) | RAMA DÉCO",
    description:
      "Entreprise de rénovation à Saint-Maur-des-Fossés : meulières, maisons de caractère, appartements. Plâtrerie, peinture, parquet, salle de bains. Devis gratuit.",
    h1: "Rénovation intérieure à Saint-Maur-des-Fossés",
    kicker: "Val-de-Marne · 94",
    intro: [
      "Saint-Maur-des-Fossés est une commune de maisons de caractère : meulières de la boucle de la Marne, villas de la Belle Époque, pavillons soignés. Les propriétaires y sont attachés au bâti et cherchent une entreprise capable de le respecter.",
      "Nous travaillons ces intérieurs avec la matière d'origine : plâtre traditionnel repris plutôt que recouvert, parquets remis en état, moulures et boiseries traitées à la brosse. Le résultat doit ressembler à la maison, pas à un catalogue.",
    ],
    contexte: [
      { t: "Meulières et villas anciennes", d: "Plâtres traditionnels, parquets d'origine, moulures et boiseries : préparation longue, finitions à la main." },
      { t: "Pièces d'eau discrètes", d: "Salle de bains contemporaine intégrée sans dénaturer le caractère du logement." },
      { t: "Confort intérieur", d: "Doublages isolants non structurels, faux plafonds, éclairage encastré, menuiseries intérieures." },
    ],
    typologies: ["Meulière", "Villa ancienne", "Pavillon", "Appartement"],
    delai: "Visite technique sous 5 jours ouvrés",
    faq: [
      {
        q: "Savez-vous travailler le plâtre traditionnel ?",
        a: "Oui. Sur les maisons anciennes, nous reprenons les plâtres avec des produits compatibles plutôt que de tout recouvrir de plaques : cela préserve les reliefs, les moulures et la respiration du mur.",
      },
      {
        q: "Peut-on moderniser une meulière sans perdre son cachet ?",
        a: "C'est exactement ce que nous cherchons : conserver parquets, moulures et menuiseries d'origine, et moderniser ce qui doit l'être — réseaux, pièces d'eau, éclairage et isolation intérieure.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["val-de-marne", "champigny-sur-marne", "creteil", "chelles", "paris"],
  },
  {
    slug: "yvelines",
    name: "Yvelines",
    type: "departement",
    cp: "78",
    dept: "Yvelines (78)",
    img: IMG.chambre,
    title: "Entreprise de rénovation dans les Yvelines (78) | RAMA DÉCO",
    description:
      "Rénovation intérieure dans les Yvelines : Versailles, Sartrouville, Saint-Germain-en-Laye, Mantes-la-Jolie. Peinture, plâtrerie, sols, pièces d'eau. Devis gratuit.",
    h1: "Rénovation intérieure dans les Yvelines",
    kicker: "Département 78",
    intro: [
      "Les Yvelines réunissent un patrimoine ancien exceptionnel et des zones résidentielles récentes : hôtels particuliers versaillais, maisons de bourg, pavillons des années 70 et lotissements contemporains.",
      "Nous intervenons sur l'ensemble du département pour des rénovations intérieures d'ampleur, en général des chantiers globaux plutôt que des interventions ponctuelles — la distance depuis Villepinte rendant les projets complets plus pertinents pour tout le monde.",
    ],
    contexte: [
      { t: "Bâti ancien de caractère", d: "Plâtres traditionnels, parquets anciens, hauteurs importantes, finitions à la main." },
      { t: "Maisons résidentielles", d: "Rénovation intérieure complète : plâtrerie, sols, pièces d'eau, cuisine, électricité intérieure." },
      { t: "Chantiers globaux", d: "Tous les lots intérieurs coordonnés par un conducteur de travaux unique, planning consolidé." },
    ],
    typologies: ["Maison de caractère", "Pavillon", "Appartement", "Maison de bourg"],
    delai: "Visite technique sous 5 à 7 jours ouvrés",
    faq: [
      {
        q: "Intervenez-vous vraiment dans les Yvelines depuis Villepinte ?",
        a: "Oui, sans majoration de zone. Pour un chantier dans le 78, nous organisons la logistique différemment : approvisionnements groupés, équipes affectées à plein temps sur le site, moins d'allers-retours.",
      },
      {
        q: "Quelles communes couvrez-vous dans le 78 ?",
        a: "L'ensemble du département, avec une présence renforcée à Versailles, Sartrouville, Saint-Germain-en-Laye, Mantes-la-Jolie, Poissy, Les Mureaux, Conflans-Sainte-Honorine et Chatou.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["versailles", "sartrouville", "saint-germain-en-laye", "mantes-la-jolie", "ile-de-france"],
  },
  {
    slug: "versailles",
    name: "Versailles",
    type: "ville",
    cp: "78000",
    dept: "Yvelines (78)",
    img: IMG.parisien,
    title: "Rénovation intérieure à Versailles (78000) | RAMA DÉCO",
    description:
      "Rénovation d'appartement et de maison à Versailles : plâtrerie traditionnelle, parquet, moulures, salle de bains, peinture haut de gamme. Devis gratuit.",
    h1: "Rénovation intérieure à Versailles",
    kicker: "Yvelines · 78",
    intro: [
      "À Versailles, le bâti impose sa discipline : immeubles anciens du quartier Notre-Dame, hôtels particuliers de Saint-Louis, appartements aux hauteurs généreuses avec parquets, moulures et cheminées. Rien ici ne supporte une finition approximative.",
      "Nos chantiers versaillais sont donc des chantiers de préparation : plâtres repris avec des produits compatibles, ponçages contrôlés en lumière rasante, peintures appliquées à la brosse dans les profils. Le temps passé avant la finition est ce qui distingue le résultat.",
    ],
    contexte: [
      { t: "Immeubles anciens", d: "Plâtre traditionnel, corniches et moulures, parquets à points de Hongrie ou bâtons rompus." },
      { t: "Grandes hauteurs", d: "Moyens d'accès adaptés, préparation renforcée des surfaces, finitions homogènes du sol au plafond." },
      { t: "Pièces d'eau intégrées", d: "Salle de bains contemporaine insérée dans un volume ancien, sans dénaturer les éléments d'origine." },
    ],
    typologies: ["Appartement ancien", "Hôtel particulier", "Maison de ville", "Duplex"],
    delai: "Visite technique sous 5 à 7 jours ouvrés",
    faq: [
      {
        q: "Travaillez-vous dans les immeubles protégés du centre de Versailles ?",
        a: "Nous intervenons sur l'intérieur uniquement, sans modification de façade, de structure ni de menuiserie extérieure. Pour les biens protégés, nous respectons les prescriptions transmises par le propriétaire ou l'architecte.",
      },
      {
        q: "Comment obtenez-vous une finition parfaite sur du plâtre ancien ?",
        a: "Par la préparation : rebouchage compatible, enduit de lissage adapté, ponçage contrôlé sous éclairage rasant, puis impression et deux couches appliquées au rouleau et à la brosse dans les reliefs.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["yvelines", "saint-germain-en-laye", "sartrouville", "paris", "hauts-de-seine"],
  },
  {
    slug: "sartrouville",
    name: "Sartrouville",
    type: "ville",
    cp: "78500",
    dept: "Yvelines (78)",
    img: IMG.sol,
    title: "Travaux de rénovation à Sartrouville (78500) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Sartrouville : pavillons, appartements, peinture, sols, salle de bains, cloisons. Entreprise tous corps d'état intérieurs, devis gratuit.",
    h1: "Rénovation intérieure à Sartrouville",
    kicker: "Yvelines · 78",
    intro: [
      "Sartrouville est l'une des communes les plus peuplées des Yvelines, avec un tissu pavillonnaire dense et des résidences construites entre 1960 et 1990. Les projets y sont familiaux : moderniser, gagner en confort, créer une pièce supplémentaire.",
      "Nos interventions portent surtout sur les sols, les pièces d'eau et l'électricité intérieure — les trois postes qui datent le plus vite dans une maison des années 70. Nous les traitons dans l'ordre technique correct, sans reprise inutile.",
    ],
    contexte: [
      { t: "Pavillons des années 70", d: "Sols d'origine à déposer, ragréage, pose de stratifié ou carrelage, plinthes et seuils." },
      { t: "Salle de bains et WC", d: "Dépose, réseaux, étanchéité, carrelage, sanitaires, ventilation et éclairage." },
      { t: "Électricité intérieure", d: "Tableau remis à niveau, circuits séparés, prises et points lumineux ajoutés." },
    ],
    typologies: ["Pavillon", "Appartement", "Maison familiale", "Combles aménagés"],
    delai: "Visite technique sous 5 à 7 jours ouvrés",
    faq: [
      {
        q: "Faut-il un ragréage avant de poser un nouveau sol ?",
        a: "Dans la plupart des pavillons que nous rénovons, oui : les supports présentent des écarts de niveau supérieurs aux tolérances de pose. Le ragréage est alors chiffré séparément, au m².",
      },
      {
        q: "Pouvez-vous aménager mes combles ?",
        a: "Nous réalisons tout l'aménagement intérieur : doublages isolants, cloisons non porteuses, plafonds, sols, électricité et finitions. La modification de la charpente ou du plancher porteur relève du gros œuvre et sort de notre périmètre.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["yvelines", "saint-germain-en-laye", "versailles", "colombes", "nanterre"],
  },
  {
    slug: "saint-germain-en-laye",
    name: "Saint-Germain-en-Laye",
    type: "ville",
    cp: "78100",
    dept: "Yvelines (78)",
    img: IMG.sejour,
    title: "Rénovation intérieure à Saint-Germain-en-Laye (78100) | RAMA DÉCO",
    description:
      "Entreprise de rénovation à Saint-Germain-en-Laye : appartements anciens, maisons de caractère, plâtrerie, parquet, peinture, salle de bains. Devis gratuit.",
    h1: "Rénovation intérieure à Saint-Germain-en-Laye",
    kicker: "Yvelines · 78",
    intro: [
      "Saint-Germain-en-Laye conjugue centre historique, maisons bourgeoises et quartiers résidentiels. Les logements y sont souvent spacieux, avec de belles hauteurs et des éléments d'origine que les propriétaires souhaitent conserver.",
      "Nous abordons ces chantiers avec la même logique qu'à Versailles : préserver ce qui fait la valeur du bien, moderniser ce qui doit l'être. Réseaux, pièces d'eau, éclairage et isolation intérieure d'un côté ; plâtres, parquets et boiseries remis en état de l'autre.",
    ],
    contexte: [
      { t: "Centre historique", d: "Appartements anciens, plâtres traditionnels, parquets et moulures à conserver." },
      { t: "Maisons bourgeoises", d: "Chantier global sur plusieurs niveaux, escaliers intérieurs, pièces d'eau, cuisine." },
      { t: "Confort contemporain", d: "Doublages isolants intérieurs, faux plafonds, éclairage encastré, domotique simple." },
    ],
    typologies: ["Appartement ancien", "Maison bourgeoise", "Maison de ville", "Pavillon"],
    delai: "Visite technique sous 5 à 7 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous améliorer l'isolation intérieure d'une maison ancienne ?",
        a: "Oui, par des doublages intérieurs isolants non structurels sur les murs froids et les rampants, avec traitement des ponts thermiques accessibles. Nous n'intervenons pas sur l'isolation par l'extérieur ni sur la structure.",
      },
      {
        q: "Coordonnez-vous tous les métiers d'une rénovation complète ?",
        a: "Oui, pour l'ensemble des lots intérieurs. Nos équipes réalisent l'essentiel et les rares spécialités externes sont pilotées par notre conducteur de travaux : un seul contact, un planning, un devis.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["yvelines", "versailles", "sartrouville", "nanterre", "paris"],
  },
  {
    slug: "mantes-la-jolie",
    name: "Mantes-la-Jolie",
    type: "ville",
    cp: "78200",
    dept: "Yvelines (78)",
    img: IMG.chantier,
    title: "Rénovation & travaux intérieurs à Mantes-la-Jolie (78200) | RAMA DÉCO",
    description:
      "Travaux intérieurs à Mantes-la-Jolie : rénovation d'appartement, remise en état locative, peinture, sols, salle de bains. Devis gratuit, planning ferme.",
    h1: "Rénovation et travaux intérieurs à Mantes-la-Jolie",
    kicker: "Yvelines · 78",
    intro: [
      "Mantes-la-Jolie connaît un renouvellement urbain important, avec des logements réhabilités, des programmes neufs et un parc ancien à moderniser. Nous y intervenons principalement pour des chantiers complets : appartements, pavillons et locaux.",
      "La distance depuis Villepinte nous impose une organisation particulière : équipes affectées à plein temps sur le site, approvisionnements groupés, planning resserré. Résultat, un chantier plus court et mieux tenu qu'avec des interventions dispersées.",
    ],
    contexte: [
      { t: "Parc ancien à moderniser", d: "Réseaux repris, pièces d'eau refaites, sols homogènes, peinture complète." },
      { t: "Remise en état locative", d: "Chantier court et daté, photos avant/après, facture détaillée pour la gestion." },
      { t: "Locaux et commerces", d: "Cloisonnement non porteur, faux plafonds, sols souples, peinture, sanitaires." },
    ],
    typologies: ["Appartement", "Pavillon", "Local commercial", "Investissement locatif"],
    delai: "Visite technique sous 6 à 8 jours ouvrés",
    faq: [
      {
        q: "Acceptez-vous les chantiers à Mantes-la-Jolie malgré la distance ?",
        a: "Oui, pour des projets suffisamment complets pour justifier une équipe dédiée sur site. Nous vous le disons franchement lors du premier échange : pour une intervention d'une demi-journée, une entreprise locale sera plus pertinente.",
      },
      {
        q: "Comment suit-on l'avancement d'un chantier éloigné ?",
        a: "Par votre espace projet en ligne : phases datées, photos d'avancement, devis, factures et messages. Beaucoup de nos clients éloignés ne se déplacent qu'à la réception.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["yvelines", "sartrouville", "saint-germain-en-laye", "versailles", "ile-de-france"],
  },
  {
    slug: "essonne",
    name: "Essonne",
    type: "departement",
    cp: "91",
    dept: "Essonne (91)",
    img: IMG.neuf,
    title: "Entreprise de rénovation dans l'Essonne (91) | RAMA DÉCO",
    description:
      "Rénovation intérieure dans l'Essonne : Évry-Courcouronnes, Corbeil-Essonnes, Massy, Savigny-sur-Orge. Peinture, sols, cloisons, pièces d'eau. Devis gratuit.",
    h1: "Rénovation intérieure dans l'Essonne",
    kicker: "Département 91",
    intro: [
      "L'Essonne mêle villes nouvelles, centres anciens et vastes zones pavillonnaires. Le parc est donc très varié : grands ensembles d'Évry, maisons de bourg de Corbeil, résidences récentes de Massy et pavillons de la vallée de l'Orge.",
      "Nous y intervenons sur des chantiers complets, avec des équipes affectées à plein temps sur le site. Cette organisation permet de tenir des plannings courts malgré la distance, et de garder un interlocuteur unique du devis à la réception.",
    ],
    contexte: [
      { t: "Villes nouvelles", d: "Appartements des années 70-90 : sols, pièces d'eau, cloisons légères et électricité intérieure." },
      { t: "Centres anciens", d: "Maisons de bourg : plâtrerie, doublages, sols, salle de bains, cuisine." },
      { t: "Pavillonnaire", d: "Rénovation intérieure complète ou par lots, combles et sous-sols aménagés." },
    ],
    typologies: ["Appartement", "Maison de bourg", "Pavillon", "Logement neuf"],
    delai: "Visite technique sous 5 à 7 jours ouvrés",
    faq: [
      {
        q: "Quelles communes couvrez-vous dans l'Essonne ?",
        a: "L'ensemble du département, avec une présence renforcée à Évry-Courcouronnes, Corbeil-Essonnes, Massy, Savigny-sur-Orge, Sainte-Geneviève-des-Bois, Palaiseau, Athis-Mons et Viry-Châtillon.",
      },
      {
        q: "La distance change-t-elle le prix des travaux ?",
        a: "Non, nos prix unitaires sont identiques partout en Île-de-France. Nous adaptons simplement l'organisation du chantier — équipes dédiées, approvisionnements groupés — pour éviter les temps morts.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["evry-courcouronnes", "corbeil-essonnes", "massy", "savigny-sur-orge", "ile-de-france"],
  },
  {
    slug: "evry-courcouronnes",
    name: "Évry-Courcouronnes",
    type: "ville",
    cp: "91000",
    dept: "Essonne (91)",
    img: IMG.chambre,
    title: "Rénovation d'appartement à Évry-Courcouronnes (91000) | RAMA DÉCO",
    description:
      "Travaux intérieurs à Évry-Courcouronnes : rénovation d'appartement, peinture, sols, salle de bains, électricité intérieure. Devis gratuit et planning ferme.",
    h1: "Rénovation d'appartement à Évry-Courcouronnes",
    kicker: "Essonne · 91",
    intro: [
      "Évry-Courcouronnes est née de la ville nouvelle : la majorité des logements datent des années 70 à 90, avec des volumes généreux mais des équipements datés. Cuisines fermées, salles de bains d'origine, sols collés et tableaux électriques sous-dimensionnés reviennent constamment.",
      "Nos chantiers y transforment le logement sans toucher à sa structure : réseaux repris, pièce d'eau entièrement refaite, sol homogène, peinture complète et éclairage repensé. C'est simple, mais c'est ce qui change tout au quotidien.",
    ],
    contexte: [
      { t: "Appartements de ville nouvelle", d: "Sols collés à déposer, cloisons légères, réseaux et tableau électrique à remettre à niveau." },
      { t: "Copropriétés et bailleurs", d: "Remise en état locative datée, photos avant/après, facture détaillée poste par poste." },
      { t: "Confort phonique", d: "Doublages acoustiques intérieurs sur murs et plafonds mitoyens, sans intervention structurelle." },
    ],
    typologies: ["Appartement", "Investissement locatif", "Duplex", "Studio"],
    delai: "Visite technique sous 6 jours ouvrés",
    faq: [
      {
        q: "Pouvez-vous améliorer l'isolation phonique entre logements ?",
        a: "Oui, par des doublages intérieurs acoustiques : ossature désolidarisée, laine minérale haute densité, plaques phoniques. Ces travaux ne touchent pas la structure et le gain est immédiatement perceptible.",
      },
      {
        q: "Combien de temps dure la rénovation d'un T3 ?",
        a: "Comptez 4 à 7 semaines pour une rénovation intérieure complète avec réseaux repris, salle de bains refaite, sols et peinture. Un rafraîchissement seul tient en 8 à 12 jours ouvrés.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["essonne", "corbeil-essonnes", "massy", "savigny-sur-orge", "ile-de-france"],
  },
  {
    slug: "corbeil-essonnes",
    name: "Corbeil-Essonnes",
    type: "ville",
    cp: "91100",
    dept: "Essonne (91)",
    img: IMG.peinture,
    title: "Travaux de rénovation à Corbeil-Essonnes (91100) | RAMA DÉCO",
    description:
      "Rénovation intérieure à Corbeil-Essonnes : maisons de bourg, appartements, peinture, sols, plâtrerie, salle de bains. Entreprise sérieuse, devis gratuit.",
    h1: "Rénovation intérieure à Corbeil-Essonnes",
    kicker: "Essonne · 91",
    intro: [
      "Corbeil-Essonnes possède un centre ancien dense, avec des maisons de bourg mitoyennes, des immeubles anciens et un parc collectif plus récent en périphérie. Les supports y sont souvent hétérogènes d'une pièce à l'autre.",
      "Notre première étape est donc toujours le diagnostic : humidité de surface, planéité, nombre de couches de sol, état des plâtres. Chiffrer sans avoir regardé sous les revêtements, c'est promettre un prix qui ne tiendra pas.",
    ],
    contexte: [
      { t: "Maisons de bourg", d: "Plâtres anciens, planchers bois, mitoyenneté : préparation soignée et doublages phoniques." },
      { t: "Humidité de surface", d: "Dépose des revêtements atteints, assainissement du support, enduits et peintures adaptés, ventilation reprise." },
      { t: "Collectif de périphérie", d: "Rafraîchissement complet, pièces d'eau, sols, électricité intérieure." },
    ],
    typologies: ["Maison de bourg", "Appartement ancien", "Pavillon", "Logement locatif"],
    delai: "Visite technique sous 6 jours ouvrés",
    faq: [
      {
        q: "Traitez-vous les problèmes d'humidité ?",
        a: "Nous traitons les désordres de surface : dépose des revêtements atteints, assainissement et préparation du support, enduits et peintures adaptés, amélioration de la ventilation. Les causes structurelles — infiltrations en façade, remontées capillaires — relèvent d'une autre spécialité et nous vous orientons.",
      },
      {
        q: "Par quoi commencer une rénovation intérieure ?",
        a: "Par ce qui salit et ce qui traverse les murs : dépose, plomberie et électricité, puis plâtrerie, puis sols et peinture. Inverser cet ordre coûte toujours plus cher.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["essonne", "evry-courcouronnes", "savigny-sur-orge", "massy", "ile-de-france"],
  },
  {
    slug: "massy",
    name: "Massy",
    type: "ville",
    cp: "91300",
    dept: "Essonne (91)",
    img: IMG.cuisine,
    title: "Rénovation intérieure à Massy (91300) | RAMA DÉCO",
    description:
      "Rénovation d'appartement et second œuvre à Massy : peinture, sols, cuisine, salle de bains, finitions de logement neuf. Devis gratuit et estimation en ligne.",
    h1: "Rénovation intérieure à Massy",
    kicker: "Essonne · 91",
    intro: [
      "Massy s'est largement renouvelée autour de ses gares : nombreux programmes neufs, résidences récentes et logements des années 70 à moderniser. Nos interventions y sont donc souvent des finitions de second œuvre autant que des rénovations classiques.",
      "Sur le neuf, notre rôle est clair : peinture de finition soignée, sols, faïence complémentaire, compléments électriques, portes et plinthes, puis levée des réserves constatées à la livraison, avec un relevé photographique exploitable auprès du promoteur.",
    ],
    contexte: [
      { t: "Logements neufs", d: "Peinture de finition, sols, faïence, compléments électriques, plinthes et portes." },
      { t: "Levée de réserves", d: "Relevé technique photographique poste par poste, reprise des défauts de livraison." },
      { t: "Résidences des années 70", d: "Cuisine, salle de bains, sols et peinture, remise à niveau de l'électricité intérieure." },
    ],
    typologies: ["Logement neuf", "Appartement", "Duplex", "Local professionnel"],
    delai: "Visite technique sous 6 jours ouvrés",
    faq: [
      {
        q: "Intervenez-vous après la livraison d'un logement neuf ?",
        a: "Oui, c'est une part importante de notre activité : finitions non prévues par le promoteur, peinture, sols, faïence complémentaire, portes, plinthes, et reprise des réserves constatées au procès-verbal.",
      },
      {
        q: "Travaillez-vous en sous-traitance pour des promoteurs ?",
        a: "Oui, sur les lots de second œuvre intérieur uniquement. Nous fournissons décennale, RC pro et attestation de vigilance URSSAF, et nous respectons les plannings tous corps d'état.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["essonne", "evry-courcouronnes", "savigny-sur-orge", "corbeil-essonnes", "hauts-de-seine"],
  },
  {
    slug: "savigny-sur-orge",
    name: "Savigny-sur-Orge",
    type: "ville",
    cp: "91600",
    dept: "Essonne (91)",
    img: IMG.sdb,
    title: "Rénovation de maison à Savigny-sur-Orge (91600) | RAMA DÉCO",
    description:
      "Rénovation intérieure de pavillon à Savigny-sur-Orge : salle de bains, cuisine, sols, peinture, électricité. Entreprise tous corps d'état, devis gratuit.",
    h1: "Rénovation de maison à Savigny-sur-Orge",
    kicker: "Essonne · 91",
    intro: [
      "Savigny-sur-Orge est une commune très pavillonnaire, avec beaucoup de maisons construites entre 1930 et 1975 et occupées longtemps par les mêmes familles. Les logements sont entretenus mais datés : c'est la modernisation qui domine, plus que la réparation.",
      "Les demandes portent surtout sur la salle de bains, la cuisine et les sols, souvent avec un objectif de confort à long terme : douche de plain-pied, éclairage renforcé, revêtements faciles à entretenir.",
    ],
    contexte: [
      { t: "Modernisation de l'existant", d: "Teintes claires, sols contemporains, faux plafonds avec spots, portes intérieures remplacées." },
      { t: "Salle de bains accessible", d: "Douche de plain-pied, receveur extra-plat, barre d'appui, sol antidérapant, éclairage renforcé." },
      { t: "Pavillons familiaux", d: "Chantier phasé pièce par pièce pour permettre à la famille de rester sur place." },
    ],
    typologies: ["Pavillon", "Maison individuelle", "Rénovation senior", "Appartement"],
    delai: "Visite technique sous 6 jours ouvrés",
    faq: [
      {
        q: "Réalisez-vous des salles de bains adaptées au maintien à domicile ?",
        a: "Oui : douche de plain-pied ou receveur extra-plat, sol antidérapant, barres d'appui fixées dans un support renforcé, WC surélevé, éclairage sans zone d'ombre. Ces aménagements se combinent avec une finition soignée.",
      },
      {
        q: "Peut-on rester dans la maison pendant les travaux ?",
        a: "Oui, dans la grande majorité des cas. Nous phasons le chantier pièce par pièce, protégeons les circulations, isolons les zones poussiéreuses et nettoyons chaque soir.",
      },
      ...FAQ_COMMUNE,
    ],
    voisins: ["essonne", "evry-courcouronnes", "corbeil-essonnes", "massy", "val-de-marne"],
  },
];

export const zoneBySlug = (slug) => ZONES.find((z) => z.slug === slug);
export const zoneUrl = (slug) => `/renovation/${slug}`;
export const VILLES = ZONES.filter((z) => z.type === "ville");
export const TERRITOIRES = ZONES.filter((z) => z.type !== "ville");
